<template>
  <div id="LaborContract"  v-loading="loading">
    <div class="buttons" v-loading="loading">
      <el-button type="primary" @click="PrintContractA" style="margin: 10px 0"
        >打印
      </el-button>
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="saveContractA"
        style="margin: 10px 0"
        v-if="dialogForm.approveStatus != 3 && dialogForm.approveStatus != 2"
        >保存
      </el-button>
      <el-button type="primary" @click="setWatermark" style="margin: 10px 0"
        >设置水印
      </el-button>
      <div style="display: inline-flex; width: 300px;margin-left:140px;">
        <el-input v-model="inputPages" placeholder="总页数" style="margin-left: 10px;"></el-input>
        <el-input v-model="inputHeight" placeholder="单页高" style="margin-left: 10px;"></el-input>
        <el-input v-model="inputPosx" placeholder="偏移量" style="margin-left: 10px;"></el-input>
      </div>
    </div>
    <div
      ref="HTMLLaborContract"
      id="HTMLLaborContract"
      :class="printClass"
      :key="printClass"     
    >
      <div class="HTMLLaborContract1">
        <div style="position: relative">
          <p
            class="contract_word_p"
            style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: right"
          >
            <span style="font-size: 20px; font-family: 宋体; color: red">N</span
            ><span style="font-size: 20px; font-family: 宋体; color: red"
              >O</span
            ><span style="font-size: 20px; font-family: 宋体; color: red"
              >：{{ dialogForm.flowNo || "" }}</span
            >
          </p>

          <p
            class="contract_word_p"
            style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: right"
          >
            <span
              style="
                position: absolute;
                z-index: 8;
                left: 10px;
                top: 2px;
                width: 44px;
                height: 57px;
              "
              ><img
                width="44"
                height="57"
                src="../../../assets/images/subContract/LaborContract/logo.png"
                alt="路桥logo" /></span
            ><span style="font-size: 20px; font-family: 宋体">合同编号：</span
            ><span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 10cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="serialNumber"
              >{{ detailForm.serialNumber }}</span
            ><span style="font-family: 宋体"></span>
          </p>
        </div>
         <div class="top_content">
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: right"
        >
          <span
            ><span style="font-size: 20px; font-family: 宋体"
              >&nbsp;</span
            ></span
          >
        </p>

        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: right"
        >
          <span
            ><span style="font-size: 20px; font-family: 宋体"
              >&nbsp;</span
            ></span
          >
        </p>

        <p
          id="spaceLine"
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: right"
        >
          <span
            ><span style="font-size: 20px; font-family: 宋体"
              >&nbsp;</span
            ></span
          >
        </p>

        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: center"
        >
          <strong
            ><span
              style="font-size: 56px;font-family: &#39;锐字云字库小标宋体1.0&#39;;letter-spacing: 2px"
              >劳务合作协议书</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify"
        >
          <span style="font-family: 宋体">&nbsp;</span>
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify"
        >
          <span style="font-family: 宋体">&nbsp;</span>
        </p>
        <!-- <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify"
        >
          <span style="font-family: 宋体">&nbsp;</span>
        </p> -->
        <!-- <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify"
        >
          <span style="font-family: 宋体">&nbsp;</span>
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify"
        >
          <span style="font-family: 宋体">&nbsp;</span>
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify"
        >
          <span style="font-family: 宋体">&nbsp;</span>
        </p> -->
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify"
        >
          <span style="font-family: 宋体">&nbsp;</span>
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify"
        >
          <span style="font-family: 宋体">&nbsp;</span>
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify"
        >
          <span style="font-family: 宋体">&nbsp;</span>
        </p>
        <p
          class="contract_word_p"
          style="
            font-size: 14px;
            text-align: justify;
            text-indent: 21px;
            line-height: 56px;
          "
        >
          <strong>
            <span style="font-size: 21px; font-family: 宋体; font-weight: 600">
              甲&nbsp;&nbsp;方：
              <span
                style="
                  border-bottom: 1px solid rgb(44, 62, 80);
                  outline: 0;
                  text-indent: 5px;
                  display: inline-block;
                  min-width: 14cm;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                class="partyA"
                >{{ detailForm.partyA }}</span
              >
            </span>
          </strong>
        </p>
        <p
          class="contract_word_p"
          style="
            font-size: 14px;
            text-align: justify;
            text-indent: 21px;
            line-height: 56px;
            margin-bottom: 6px;
          "
        >
          <strong>
            <span style="font-size: 21px; font-family: 宋体; font-weight: 600">
              乙&nbsp;&nbsp;方：
              <span
                style="
                  border-bottom: 1px solid rgb(44, 62, 80);
                  outline: 0;
                  min-width: 14cm;
                  display: inline-block;
                  text-indent: 5px;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                class="partyB"
                >{{ detailForm.partyB }}</span
              >
            </span>
          </strong>
        </p>
        <div
          id="projectName"
          style="
            display: flex;
            font-size: 21px;
            font-family: 宋体;
            font-weight: 600;
            line-height: 70px;
          "
        >
          <div style="text-indent: 21px">项目名称：</div>
          <div style="width: 14.2cm; margin-left: 10px">
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 14.2cm;
                padding-bottom: 20px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="projectName"
              >{{ detailForm.projectName }}</span
            >
          </div>
        </div>
        <p
          class="contract_word_p"
          style="
            font-size: 14px;
            text-align: justify;
            text-indent: 21px;
            line-height: 56px;
          "
        >
          <strong
            ><span style="font-size: 21px; font-family: 宋体; font-weight: 600"
              >签订地点：
              <span
                style="
                  border-bottom: 1px solid rgb(44, 62, 80);
                  outline: 0;
                  min-width: 14cm;
                  display: inline-block;
                  text-indent: 5px;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                class="signPlace"
                >{{ detailForm.signPlace }}</span
              ></span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;text-indent: 21px"
        >
          <span style="font-size: 21px; font-family: 宋体"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
          >
        </p>

        <p
          class="contract_word_p"
          style="
            font-size: 14px;
            text-align: center;
            text-indent: 21px;
            vertical-align: middle;
          "
        >
          <span
            style="font-size: 21px; font-family: 宋体"
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="signDate"
            >{{ detailForm.signDate }}</span
          >
        </p>
        <!-- <p class="contract_word_p">
          <strong style="font-size: medium; white-space: normal"
            ><span style="font-size: 24px; font-family: 宋体"><br /></span
          ></strong>
        </p> -->
        <div id="first_part">
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: center;white-space: normal;line-height: 37px;page-break-before:always "
        >
          <strong
            ><span style="font-size: 24px; font-family: 宋体"
              >工程劳务合作协议书</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: right;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp;&nbsp;&nbsp; </span
          ><span style="font-size: 16px; font-family: 宋体">合同编号：</span
          ><span
            style="
              border-bottom: 1px solid rgb(44, 62, 80);
              outline: 0;
              text-indent: 5px;
              display: inline-block;
              min-width: 10cm;
            "
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="xysContractNum"
            >{{ detailForm.xysContractNum }}</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >本合同分为两部分，第一部分为协议书，第二部分为条款内容。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: center;white-space: normal;line-height: 37px"
        >
          <strong
            ><span style="font-size: 20px; font-family: 宋体"
              >第一部分 协议书</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: left;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >承包人：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 10cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              >{{ detailForm.partyA }}</span
            >（以下简称甲方）；</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: left;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >劳务人：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 10cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              >{{ detailForm.partyB }}</span
            >（以下简称乙方）；</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >依照《中华人民共和国民法典》及其他有关法律、法规的规定，遵循平等、自愿、公平和诚实信用的原则，鉴于<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 10cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="fbr"
              >{{ detailForm.fbr }}</span
            >（以下简称为“发包人”）与甲方已经达成<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 10cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="sgzcbxy"
              >{{ detailForm.sgzcbxy }}</span
            >施工总承包协议（以下称为“总包合同”），甲乙双方就工程劳务合作事项协商达成一致，订立本合同。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >第一条 乙方资质情况</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >统一社会信用代码：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 13cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="shxydm"
              >{{ detailForm.shxydm }}</span
            >；</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >注册资金：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 6cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="zczj"
              >{{ detailForm.zczj }}</span
            >万元；&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            font-size: 14px;
            text-align: justify;
            white-space: normal;
            text-indent: 32px;
            line-height: 37px;
          "
        >
          <span style="font-size: 16px; font-family: 宋体">经营范围：</span>
        </p>
        <p
          class="contract_word_p"
          style="
            font-size: 16px;
            font-family: 宋体;
            text-align: justify;
            white-space: normal;
            line-height: 37px;
          "
        >
          <span
            style="
              outline: 0;
              text-indent: 5px;
              display: block;
              max-width: 666px;
              text-decoration: underline;
              white-space: pre-line;
            "
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="zczj1"
            >{{ detailForm.zczj1 || "无。" }}</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >第二条 工程内容</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">1</span
          ><span style="font-size: 16px; font-family: 宋体"
            >、工程名称：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 14cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="gcmc"
              >{{ detailForm.gcmc }}</span
            >；</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">2</span
          ><span style="font-size: 16px; font-family: 宋体"
            >、工程地点：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 14cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="gcdd"
              >{{ detailForm.gcdd }}</span
            >；</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">3</span
          ><span style="font-size: 16px; font-family: 宋体"
            >、桩号范围：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 14cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="zhff"
              >{{ detailForm.zhff }}</span
            >；</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">4</span
          ><span style="font-size: 16px; font-family: 宋体"
            >、工程劳务内容：计价项目见附后工程量清单中的细目，</span
          ><span style="font-size: 16px; font-family: 宋体"
            >（包括但不限于人员及设备进退场、施工准备、按发包人标准要求的临时工程、住房等临时设施、完成施工图纸工程、安全生产和文明施工措施、地下障碍物查勘及保护、工程照管、工程保修等，以及迎接发包人等上级检查进行的便道维修、清理，标志标牌设立，垃圾清理、打扫卫生等工作内容）。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >若在本合同工程的施工过程中，甲方因本合同工程施工衔接的需要，须对本合同中乙方的承包范围及内容给予适当的增加或减少时，乙方应积极地予以接受，并作为本合同工程的组成部分全面、实际地履行，单价不变，新增项目单价执行甲方内部指导单价。除非本合同其它条款对此等增加或减少的情况另有规定，乙方不得据此向甲方提出任何索赔或权利主张。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >第三条 施工期限</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">1</span
          ><span style="font-size: 16px; font-family: 宋体"
            >、开工日期：本劳务工程定于<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 2.5cm;
                text-align: center;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="kgrqYear"
              >{{ detailForm.kgrqYear }}</span
            >年<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 2cm;
                text-align: center;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="kgrqMonth"
              >{{ detailForm.kgrqMonth }} </span
            >月<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                text-align: center;
                min-width: 2cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="kgrqDay"
              >{{ detailForm.kgrqDay }}</span
            >日开工；</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">2</span
          ><span style="font-size: 16px; font-family: 宋体"
            >、交工日期：本劳务工程定于<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 2.5cm;
                text-align: center;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="jgrqYear"
              >{{ detailForm.jgrqYear }}</span
            >年<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 2cm;
                text-align: center;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="jgrqMonth"
              >{{ detailForm.jgrqMonth }}</span
            >月<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                text-align: center;
                min-width: 2cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="jgrqDay"
              >{{ detailForm.jgrqDay }}</span
            >日交工；</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">3</span
          ><span style="font-size: 16px; font-family: 宋体"
            >、合同工期总日历天数为：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 3cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="htgqHoleDay"
              >{{ detailForm.htgqHoleDay }}</span
            >天。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >第四条 劳务合同价款</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >含税总价：人民币(大写)
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 8cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="hszjDX"
              >{{ detailForm.hszjDX }}</span
            >（¥<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 4cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="hszjXJ"
              >{{ detailForm.hszjXJ }}</span
            >）<span>，</span>（不含税价：¥<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 5cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="bhsj"
              >{{ detailForm.bhsj }}</span
            >， 税费：¥<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 5cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="sf"
              >{{ detailForm.sf }}</span
            >）</span
          ><span style="font-size: 16px; font-family: 宋体">。</span>
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >第五条 工程质量标准</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 28px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >本工程质量标准双方约定为：<strong
              ><span
                style="
                  border-bottom: 1px solid rgb(44, 62, 80);
                  outline: 0;
                  text-indent: 5px;
                  display: inline-block;
                  min-width: 4cm;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                class="zlbzssyd"
                >{{ detailForm.zlbzssyd }}</span
              ></strong
            >。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >第六条 合同文件</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >下列文件构成本施工劳务合同不可分割的整体，各文件相互解释、互为说明，如有不明确或不一致之处，以下列次序在先者为准：</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">1</span
          ><span style="font-size: 16px; font-family: 宋体"
            >、双方商定的补充协议或合同期内经双方签署的备忘录；</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">2</span
          ><span style="font-size: 16px; font-family: 宋体"
            >、本合同协议书；</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">3</span
          ><span style="font-size: 16px; font-family: 宋体"
            >、工程量清单；</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">4</span
          ><span style="font-size: 16px; font-family: 宋体"
            >、中标通知书（如有）；</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">5</span
          ><span style="font-size: 16px; font-family: 宋体"
            >、本合同相关图纸及技术文件；</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">6</span
          ><span style="font-size: 16px; font-family: 宋体">、</span
          ><span style="font-size: 16px; font-family: 宋体"
            >合同履行过程中，甲方和乙方协商一致的其他书面文件；</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">7</span
          ><span style="font-size: 16px; font-family: 宋体"
            >、根据管理的需要，双方另行签订的安全环保协议书、廉政建设协议书等。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >本合同一经签署即生效。乙方即被视为已经充分并准确地理解了本工程、本工程劳务合同的全部相关内容，且同意按本工程劳务合同约定的全部内容全面履行。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >第七条 其他约定</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">1</span
          ><span style="font-size: 16px; font-family: 宋体"
            >、本协议书中有关词语的含义与本合同第二部分《合同条款》中分别赋予它们的定义相同；</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">2</span
          ><span style="font-size: 16px; font-family: 宋体"
            >、劳务人向承包人承诺，按照合同约定的工期和质量标准，完成本协议书第二条约定的工程（以下简称为“劳务工程”），并在质量保修期内承担保修责任；</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">3</span
          ><span style="font-size: 16px; font-family: 宋体"
            >、劳务人向承包人承诺，履行总包合同中与劳务工程有关的承包人的所有义务，并与承包人承担履行劳务工程合同以及确保劳务工程质量的连带责任。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">&nbsp;</span
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >第八条 合同的生效</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: left;white-space: normal;text-indent: 28px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >合同订立时间：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 3cm;
                text-align: center;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="htdlYear"
              >{{ detailForm.htdlYear }}</span
            >年<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 2cm;
                text-align: center;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="htdlMonth"
              >{{ detailForm.htdlMonth }}</span
            >月<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                text-align: center;
                min-width: 2cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="htdlDay"
              >{{ detailForm.htdlDay }}</span
            >日；合同订立地点：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 4cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="htdlAddress"
              >{{ detailForm.htdlAddress }}</span
            >。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 28px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >本合同经双方签字并盖章后生效。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 9px;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >第九条 合同的期限</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 9px;line-height: 37px;"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >&nbsp;&nbsp;
            </span></strong
          ><span style="font-size: 16px; font-family: 宋体"
            >本合同全部工程竣工验收合格后，保修期内不发生质量事故或虽发生质量事故而经修补后达到质量标准，并结清全部余款后，本合同终止。</span
          >
        </p>
        <!-- <p
        class="contract_word_p"
        style="margin: 0 0 0 392px;font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px;page-break-before: always;"
      >
        <span style="font-size: 16px; font-family: 宋体">&nbsp;</span>
      </p> -->
     
      </div> <!--for first-part-->
      </div>

        <table
          width="100%;"
          style="page-break-after: always; page-break-before: always;"
        >
          <tr style="vertical-align: top">
            <td width="50%">
              <div
                style="
                  display: flex;
                  font-size: 16px;
                  font-family: 宋体;
                  line-height: 37px;
                "
              >
                <div>甲方：</div>
                <div style="width: 7.5cm">
                  <span
                    style="
                      border-bottom: 1px solid rgb(44, 62, 80);
                      outline: 0;
                      min-width: 7.5cm;
                      padding-bottom: 10px;
                      word-break: break-all;
                    "
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    class="htPartA"
                    >{{ detailForm.htPartA }}</span
                  >
                </div>
              </div>
              <!-- <p
                class="contract_word_p"
                style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align:left; white-space: normal;line-height: 37px"
              >
                <span style="font-size: 16px; font-family: 宋体"
                  >甲方：<span
                    style="
                      border-bottom: 1px solid rgb(44, 62, 80);
                      outline: 0;
                      text-indent: 5px;
                      display: inline-block;
                      min-width: 7.2cm;
                    "
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    class="htPartA"
                    >{{ detailForm.htPartA }}</span
                  >
                </span>
              </p> -->
              <p
                class="contract_word_p"
                style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
              >
                <span style="font-size: 16px; font-family: 宋体"
                  >法定代表人或：<span
                    style="
                      border-bottom: 1px solid rgb(44, 62, 80);
                      outline: 0;
                      text-indent: 5px;
                      display: inline-block;
                      min-width: 5.5cm;
                    "
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    class="fddbrOthers"
                    >{{ detailForm.fddbrOthers }}</span
                  ></span
                >
              </p>
              <p
                class="contract_word_p"
                style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
              >
                <span style="font-size: 16px; font-family: 宋体"
                  >委托代理人：<span
                    style="
                      border-bottom: 1px solid rgb(44, 62, 80);
                      outline: 0;
                      text-indent: 5px;
                      display: inline-block;
                      min-width: 5.9cm;
                    "
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    class="wtdlr"
                    >{{ detailForm.wtdlr }}</span
                  ></span
                >
              </p>
              <p
                class="contract_word_p"
                style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
              >
                <span style="font-size: 16px; font-family: 宋体"
                  >电话：<span
                    style="
                      border-bottom: 1px solid rgb(44, 62, 80);
                      outline: 0;
                      text-indent: 5px;
                      display: inline-block;
                      min-width: 7.2cm;
                    "
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    class="phone"
                    >{{ detailForm.phone }}</span
                  ></span
                >
              </p>
              <p
                class="contract_word_p"
                style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
              >
                <span style="font-size: 16px; font-family: 宋体"
                  >邮箱：<span
                    style="
                      border-bottom: 1px solid rgb(44, 62, 80);
                      outline: 0;
                      text-indent: 5px;
                      display: inline-block;
                      min-width: 7.2cm;
                    "
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    class="email"
                    >{{ detailForm.email }}</span
                  ></span
                >
              </p>
              <div
                style="
                  display: flex;
                  font-size: 16px;
                  font-family: 宋体;
                  line-height: 37px;
                "
              >
                <div>开户银行：</div>
                <div style="width: 6.6cm">
                  <span
                    style="
                      border-bottom: 1px solid rgb(44, 62, 80);
                      outline: 0;
                      min-width: 6.6cm;
                      padding-bottom: 10px;
                      word-break: break-all;
                    "
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    class="openBank"
                    >{{
                      detailForm.openBank ? detailForm.openBank : "无 "
                    }}</span
                  >
                </div>
              </div>
              <p
                class="contract_word_p"
                style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
              >
                <span style="font-size: 16px; font-family: 宋体"
                  >账号：<span
                    style="
                      border-bottom: 1px solid rgb(44, 62, 80);
                      outline: 0;
                      text-indent: 5px;
                      display: inline-block;
                      min-width: 7.2cm;
                    "
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    class="account"
                    >{{ detailForm.account }}</span
                  ></span
                >
              </p>
              <div
                style="
                  display: flex;
                  font-size: 16px;
                  font-family: 宋体;
                  line-height: 37px;
                "
              >
                <div>单位地址：</div>
                <div style="width: 6.5cm">
                  <span
                    style="
                      border-bottom: 1px solid rgb(44, 62, 80);
                      outline: 0;
                      min-width: 6.5cm;
                      padding-bottom: 10px;
                      word-break: break-all;
                    "
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    class="workAddress"
                    >{{
                      detailForm.workAddress ? detailForm.workAddress : "无"
                    }}</span
                  >
                </div>
              </div>
              <p
                class="contract_word_p"
                style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
              >
                <span style="font-size: 16px; font-family: 宋体"
                  >邮编：<span
                    style="
                      border-bottom: 1px solid rgb(44, 62, 80);
                      outline: 0;
                      text-indent: 5px;
                      display: inline-block;
                      min-width: 7.2cm;
                    "
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    class="emailYB"
                    >{{ detailForm.emailYB }}</span
                  ></span
                >
              </p>
            </td>

            <td>
              <div
                style="
                  display: flex;
                  font-size: 16px;
                  font-family: 宋体;
                  line-height: 37px;
                "
              >
                <div>乙方：</div>
                <div style="width: 7.5cm">
                  <span
                    style="
                      border-bottom: 1px solid rgb(44, 62, 80);
                      outline: 0;
                      min-width: 7.5cm;
                      padding-bottom: 10px;
                      word-break: break-all;
                    "
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    class="htPartB"
                    >{{
                      detailForm.htPartB ? detailForm.htPartB : "无 (盖章）"
                    }}</span
                  >
                </div>
              </div>
              <p
                class="contract_word_p"
                style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
              >
                <span style="font-size: 16px; font-family: 宋体"
                  >法定代表人或：<span
                    style="
                      border-bottom: 1px solid rgb(44, 62, 80);
                      outline: 0;
                      text-indent: 5px;
                      display: inline-block;
                      min-width: 5.5cm;
                    "
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    class="fddbrOthersB"
                    >{{ detailForm.fddbrOthersB }}</span
                  ></span
                >
              </p>
              <p
                class="contract_word_p"
                style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
              >
                <span style="font-size: 16px; font-family: 宋体"
                  >委托代理人：<span
                    style="
                      border-bottom: 1px solid rgb(44, 62, 80);
                      outline: 0;
                      text-indent: 5px;
                      display: inline-block;
                      min-width: 5.9cm;
                    "
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    class="wtdlrB"
                    >{{ detailForm.wtdlrB }}</span
                  ></span
                >
              </p>
              <p
                class="contract_word_p"
                style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
              >
                <span style="font-size: 16px; font-family: 宋体"
                  >电话：<span
                    style="
                      border-bottom: 1px solid rgb(44, 62, 80);
                      outline: 0;
                      text-indent: 5px;
                      display: inline-block;
                      min-width: 7.2cm;
                    "
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    class="phoneB"
                    >{{ detailForm.phoneB }}</span
                  ></span
                >
              </p>
              <p
                class="contract_word_p"
                style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
              >
                <span style="font-size: 16px; font-family: 宋体"
                  >邮箱：<span
                    style="
                      border-bottom: 1px solid rgb(44, 62, 80);
                      outline: 0;
                      text-indent: 5px;
                      display: inline-block;
                      min-width: 7.2cm;
                    "
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    class="emailB"
                    >{{ detailForm.emailB }}</span
                  ></span
                >
              </p>
              <div
                style="
                  display: flex;
                  font-size: 16px;
                  font-family: 宋体;
                  line-height: 37px;
                "
              >
                <div>开户银行：</div>
                <div style="width: 6.5cm">
                  <span
                    style="
                      border-bottom: 1px solid rgb(44, 62, 80);
                      outline: 0;
                      min-width: 6.5cm;
                      padding-bottom: 10px;
                      word-break: break-all;
                    "
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    class="openBankB"
                    >{{
                      detailForm.openBankB ? detailForm.openBankB : "无 "
                    }}</span
                  >
                </div>
              </div>
              <p
                class="contract_word_p"
                style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
              >
                <span style="font-size: 16px; font-family: 宋体"
                  >账号：<span
                    style="
                      border-bottom: 1px solid rgb(44, 62, 80);
                      outline: 0;
                      text-indent: 5px;
                      display: inline-block;
                      min-width: 7.2cm;
                    "
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    class="accountB"
                    >{{ detailForm.accountB }}</span
                  ></span
                >
              </p>
              <div
                style="
                  display: flex;
                  font-size: 16px;
                  font-family: 宋体;
                  line-height: 37px;
                "
              >
                <div>单位地址：</div>
                <div style="width: 6.5cm">
                  <span
                    style="
                      border-bottom: 1px solid rgb(44, 62, 80);
                      outline: 0;
                      min-width: 6.5cm;
                      padding-bottom: 10px;
                      word-break: break-all;
                    "
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    class="workAddressB"
                    >{{
                      detailForm.workAddressB ? detailForm.workAddressB : "无"
                    }}</span
                  >
                </div>
              </div>
              <p
                class="contract_word_p"
                style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
              >
                <span style="font-size: 16px; font-family: 宋体"
                  >邮编：<span
                    style="
                      border-bottom: 1px solid rgb(44, 62, 80);
                      outline: 0;
                      text-indent: 5px;
                      display: inline-block;
                      min-width: 7.2cm;
                    "
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    class="emailYBB"
                    >{{ detailForm.emailYBB }}</span
                  ></span
                >
              </p>
            </td>
          </tr>
        </table>

        <div id="second_part">
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px;"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
          ><strong
            ><span style="font-size: 20px; font-family: 宋体"
              >第二部分 合同条款</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >一、词语定义、法律法规及图纸</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >&nbsp;&nbsp;1.
            </span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >词语定义</span
            ></strong
          ><span style="font-size: 16px; font-family: 宋体">&nbsp;&nbsp;</span>
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp;1.1 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >发包人：指在总包合同协议书中约定的具有工程发包主体资格和支付工程价款能力的当事人，以及取得该当事人资格的合法继承人。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp;1.2 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >承包人（甲方）：指在总包合同协议书中约定的，被发包人接受的具有工程施工总承包主体资格的当事人，以及取得该当事人资格的合法继承人。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">&nbsp;&nbsp;1.3</span
          ><span style="font-size: 16px; font-family: 宋体"
            >劳务人（乙方）：指在本劳务合同协议书中约定的，被甲方接受的具有劳务该工程资格的当事人，以及取得该当事人资格的合法继承人。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp;1.4 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >总包工程：指由发包人和甲方在总包合同协议书中约定的承包范围内的工程。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="margin: 0 5px 0 0;font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp;1.5 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >本合同劳务工程：指由甲方和乙方在本合同协议书中约定的范围内的工程。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp;1.6 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >工程师：指在总包合同中约定的由工程监理单位委派的工程师或发包人指定的履行总包合同的代表，其具体身份和职权由发包人和甲方在总包合同专用条款中约定。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp;1.7 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >项目经理：指甲方在总包合同专用条款和本合同专用条款中指定的负责施工管理、履行总包合同及本合同的代表。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp;1.8 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >劳务项目经理：指由乙方在劳务合同专用条款中指定的负责施工管理和履行劳务合同的代表。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="margin: 10px 0;font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp;1.9 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >总包合同：指发包人与甲方之间签订的施工总承包合同或专业承包合同。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="margin: 10px 0;font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp;1.10</span
          ><span style="font-size: 16px; font-family: 宋体"
            >劳务合同：指甲方和乙方之间签订的施工合同，由协议书、合同条款组成。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="margin: 10px 0;font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp;1.11</span
          ><span style="font-size: 16px; font-family: 宋体"
            >工程建设标准：指与劳务工程相关的工程建设标准，以及经承包人确认的，对工程建设标准进行的任何修改或增补。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp;1.12</span
          ><span style="font-size: 16px; font-family: 宋体"
            >图纸：指由甲方提供的符合总包合同要求及本合同需要的所有图纸、计算书、配套说明以及相关的技术资料。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp;1.13</span
          ><span style="font-size: 16px; font-family: 宋体"
            >施工场地：指由甲方提供的由乙方用于工程施工的场地。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp;1.14</span
          ><span style="font-size: 16px; font-family: 宋体"
            >违约责任：指合同一方不履行合同义务或履行合同义务不符合约定内容，所应承担的责任。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp;1.15</span
          ><span style="font-size: 16px; font-family: 宋体"
            >索赔：指在合同履行过程中，对于并非自己的过错，而是应由对方承担责任的情况造成的实际损失，向对方提出经济补偿和（或）工期顺延的要求。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp;1.16</span
          ><span style="font-size: 16px; font-family: 宋体"
            >不可抗力：指不能预见、不能避免且不能克服的客观情况。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp;1.17</span
          ><span style="font-size: 16px; font-family: 宋体">工程照管：</span>
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">&nbsp;&nbsp;</span
          ><span style="font-size: 16px; font-family: 宋体"
            >（a）乙方应负责照管和维护完成的<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 4cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="value1"
              >{{ detailForm.value1 }}</span
            >工程，直至工程质量监督部门验收完成并交付管养单位；</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">&nbsp;&nbsp;</span
          ><span style="font-size: 16px; font-family: 宋体"
            >（b）在乙方负责照管与维护工程期间，如果工程发生损失或损害，除不可抗力原因之外，乙方均应自费弥补，并达到合同要求。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >&nbsp;&nbsp;2.
            </span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >适用法律、行政法规及工程建设标准</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp;2.1 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >适用法律和行政法规</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp;&nbsp;</span
          ><span style="font-size: 16px; font-family: 宋体"
            >《中华人民共和国民法典》《中华人民共和国公路法》
            、《中华人民共和国建筑法》、《中华人民共和国招投标法》、《中华人民共和国政府采购法》、<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                word-break: break-all;
                padding-bottom: 2px;
                line-height: 32px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="value2"
              >&nbsp;&nbsp;{{ detailForm.value2 }}</span
            >
            。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">&nbsp;&nbsp;2.2</span
          ><span style="font-size: 16px; font-family: 宋体"
            >适用工程建设标准</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span
            style="font-size: 16px; font-family: 宋体; display: inline-block"
            >&nbsp;&nbsp;2.2.1包括：
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                min-width: 14.6cm;
                padding-bottom: 2px;
                word-break: break-all;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="bk1"
              >&nbsp;{{ detailForm.bk1 || "无" }}</span
            >
          </span>
        </p>

        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp;2.2.2</span
          ><span style="font-size: 16px; font-family: 宋体"
            >甲方在本合同执行期间向乙方提出的施工技术要求，乙方及时提出施工工艺，经甲方确认后执行。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >&nbsp;&nbsp;3.
            </span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >图纸</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">&nbsp;&nbsp;3.1</span
          ><span style="font-size: 16px; font-family: 宋体"
            >甲方向乙方提供图纸一套，乙方需要增加图纸可自</span
          ><span style="font-size: 16px; font-family: 宋体">行复制。</span>
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp;3.2 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方应对甲方交付的图纸严格保密，未经甲方书面同意，不得将本工程图纸转给第三人。工程完工或工程质量保修期满后，除乙方存档需要的图纸外，乙方应将全部图纸退还给甲方。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp;3.3 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方应在施工现场保留一套完整图纸，供甲方、发包人、监理工程师及有关人员进行工程检查时使用。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="margin: 10px 0;font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >二、双方一般权利和义务</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style="margin: 10px 0;font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >&nbsp;&nbsp;4.</span
            ></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >总包合同</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style="margin: 10px 0;font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp;4.1 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >劳务人对总包合同的了解</span
          >
        </p>
        <p
          class="contract_word_p"
          style="margin: 10px 0;font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >　　承包人应提供总包合同（有关承包工程的价格内容除外）供劳务人查阅。当劳务人要求时，承包人应向劳务人提供一份总包合同（有关承包工程的价格内容除外）的副本或复印件。劳务人应全面了解总包合同的各项规定（有关承包工程的价格内容除外）。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="margin: 10px 0;font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">4.2 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >劳务人对有关劳务工程的责任</span
          >
        </p>
        <p
          class="contract_word_p"
          style="margin: 10px 0;font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >　　除本合同条款另有约定，劳务人应履行并承担总包合同中与本合同有关的承包人的所有义务与责任，同时应避免因劳务人自身行为或疏漏造成承包人违反总包合同中约定的承包人义务的情况发生。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="margin: 10px 0;font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">4.3 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >劳务人与发包人的关系</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >劳务人须服从承包人转发的发包人或工程师与本工程内容有关的指令。未经承包人允许，劳务人不得以任何理由与发包人或工程师发生直接工作联系，劳务人不得直接致函发包人或工程师，也不得直接接受发包人或工程师的指令。如劳务人与发包人或工程师发生直接工作联系，将被视为违约，并承担违约责任。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="margin: 10px 0;font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体">5.</span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >指令和决定</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style="margin: 10px 0;font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">5.1</span
          ><span style="font-size: 16px; font-family: 宋体">承包人指令</span>
        </p>
        <p
          class="contract_word_p"
          style="margin: 10px 0;font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >　　就本合同工程范围内的有关工作，承包人随时可以向劳务人发出指令，劳务人应执行承包人根据劳务合同所发出的所有指令。劳务人拒不执行指令，承包人可委托其他施工单位完成该指令事项，发生的费用加倍从应付给劳务人的相应款项中扣除。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="margin: 10px 0;font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">5.2</span
          ><span style="font-size: 16px; font-family: 宋体"
            >发包人或工程师指令</span
          >
        </p>
        <p
          class="contract_word_p"
          style="margin: 10px 0;font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >　　就本合同工程范围内的有关工作，劳务人应执行经承包人确认和转发的发包人或工程师发出的所有指令和决定。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">&nbsp;&nbsp;</span
          ><strong
            ><span style="font-size: 16px; font-family: 宋体">6. </span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >项目经理、联系方式及签证</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">6.1 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >甲方委派的担任驻工地履行本合同的项目经理为<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 2cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="projectMsgerA"
              >{{ detailForm.projectMsgerA }}</span
            >，职务：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 2cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="workA"
              >{{ detailForm.workA }}</span
            >，联系电话：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 3cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="cphoneA"
              >{{ detailForm.cphoneA }}</span
            >。甲方通讯地址为<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 4cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="caddressA"
              >{{ detailForm.caddressA }}</span
            >，邮编：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 2cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="cemailA"
              >{{ detailForm.cemailA }}</span
            >。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp;6.2 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方委派的担任驻工地履行本合同的项目经理为<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 3cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="projectMsgerB"
              >{{ detailForm.projectMsgerB }}</span
            >，职务：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 2cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="workB"
              >{{ detailForm.workB }}</span
            >，联系电话：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 3cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="cphoneB"
              >{{ detailForm.cphoneB }}</span
            >。乙方通讯地址为<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 4cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="caddressB"
              >{{ detailForm.caddressB }}</span
            >，邮编：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 2cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="cemailB"
              >{{ detailForm.cemailB }}</span
            >。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">6.3 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方所拿到的与本劳务工程相关的任何甲方签证资料均必须由甲方驻地项目经理最终签字确认后，方能作为双方结算依据。乙方承诺：若乙方所拿到的与本合同相关的任何甲方签证资料如果没有甲方驻地项目经理最终签字确认的，乙方将不再以这些无甲方驻地项目经理最终签字确认的甲方签证资料及所施工内容向甲方主张任何权利。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 28px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">6.4 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >本合同所列的通知方式均为有效联系方式，甲乙任</span
          ><span style="font-size: 16px; font-family: 宋体"
            >何一方应按本合同约定的通知方式向对方发送各类书面文件。书面文件以传真、E-mail形式发出的，发出之日视为送达；书面文件以平邮、挂号邮件或特快专递形式按本合同所列地址发出的，如劳务方无正当理由拒不接收，则自寄出之日起3日内即视为送达。甲乙任何一方更改联系方式应事先以书面形式通知对方。如因乙方及其委托代理人变更联系方式而未及时通知甲方，致使甲方不能送达通知，则自甲方寄交书面文件之日起3日内即视为送达。本合同规定的各项时限含法定节假日。如到期当日为法定节假日，则顺延至之后的第一个工作日。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 28px;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体">7. </span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >劳务用工及工资支付管理</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 28px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">7.1 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方必须遵守国家法律、行政法规和政策的规定，及时办理和完善劳动用工、社会保险等手续，合法使用员工，保护员工合法权益，不得拖欠或克扣员工、（农）民工工资。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 28px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">7.2 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方未能及时支付其员工或（农）民工工资时，乙方同意：若乙方就所劳务工程拖欠农民工工资，出现上访现象，甲方有权从乙方工程计量款中扣除相应金额发放乙方所欠农民工工资，并且乙方应向甲方支付等额违约金。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">7.3 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >甲方有权对乙方的员工工资支付等情况进行监督、检查，乙方不得以任何理由拒绝，并应为甲方的监督、检查提供便利。若乙方违反国家法律、行政法规及有关国家政策，拖欠或克扣员工工资，经甲方催告后在合理时间仍不纠正的，甲方将有权暂停支付工程款或单方面解除合同，由此造成的一切损失和责任由乙方承担。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体">8. </span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >甲方的责任</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">8.1 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >负责整个工程的生产技术、质量、安全、进度的监督管理，施工过程中的质量检查及验收；对不符合技术规范要求的操作，有权要求乙方停工整顿。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">8.2 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >统筹安排、协调解决非乙方独立使用的生产、生活临时设施、工作用水、用电设施及施工场地（双方另有约定除外）。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">8.3 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >按时提供本工程有关施工图纸，并进行技术交底。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">8.4 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >下达开工令，根据发包人、监理工程师的要求和指令，以及相关工序进展情况调整施工作业计划，传达发包人、监理会议精神和有关决议。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">8.5 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >及时交付应提供的施工场地等。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">8.6 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >根据工程进展情况或乙方要求，及时与发包人或监理工程师联系工程验收，检查应由乙方负责的工程验收资料和其他原始资料。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">8.7 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >及时审核乙方提交的工程中期结算资料，在收到发包人的工程款后按本劳务合同规定向乙方支付进度款。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">8.8 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >协助乙方办理有关手续和证件，费用由乙方自理。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">8.9 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >负责审核由乙方编制的，报甲方或发包人或监理的各种施工报表、来往文件和其他文件（包括结算资料和竣工资料）。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">8.10 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >甲方应做的其他工作。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体">9. </span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >乙方的责任&nbsp;</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">9.1 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方必须具备并提交国家认可的建筑企业资质证明文件及安全生产资质证书，按《中华人民共和国发票管理办法》开具增值税专用发票，本工程需乙方收款前将增值税专用发票交由甲方进行认证，甲方认证通过后进行付款；如开票方开具的发票不规范、不合法或涉嫌虚开，则甲方不予付款，若给甲方造成损失除应予以赔偿外，并且不能免除重新开具增值税专用发票的责任。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">9.2 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >按甲方、发包人或监理批准的施工组织设计、本劳务合同、总包合同等，保质、保量、保安全完成本工程施工及缺陷的修复。按本合同约定的时间、规格和数量及时在现场配备足够的管理、技术、施工人员，配置足够的施工所需要的机械设备、施工材料，足够的工程垫付资金。管理、技术、施工人员应符合岗位要求，符合国家有关规定；进场设备性能要保持良好，手续证件齐全。同时对进入工地内的人员、设备未经甲方书面同意，不得擅自离场。如乙方人员、设备、施工材料未经甲方同意擅自离场或运出，甲方有权全部扣除未支付乙方的工程款作为甲方损失的赔偿，对于全部扣除未支付乙方的工程款仍不能弥补甲方损失的，乙方应赔偿甲方剩余的损失。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">9.3 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方应指定驻地项目经理，以便随时解决工作中出现的问题并顺利贯彻甲方意图；现场负责人离开现场须征得甲方项目经理同意，乙方驻地项目经理不能或不适合履行本劳务合同，甲方在提前3天通知后，乙方应立即撤换并调离该人员，否则视为乙方违约。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">9.4 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >服从甲方、发包人和监理工程师的指令，对本工程的质量、安全和进度进行控制并使甲方、发包人和监理工程师满意，符合本合同及总包合同约定标准。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">9.5 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >按甲方、发包人和监理工程师要求的格式、时间，及时提供隐蔽工程验收申请单、工程质量自检报告、竣工验收申请报告、工程事故报告、月度、季度施工作业计划、用款计划和其他有关文件和资料。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">9.6 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >根据施工组织设计总进度计划的要求，提前提交下月施工计划，有阶段工期要求的提交阶段施工计划，必要时按甲方、监理工程师的要求提交旬、周施工计划，以及与完成上述阶段、时段施工计划相应的安排计划，经甲方批准后严格实施；</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">9.7 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >对本合同工程范围内的工程质量向甲方负责，</span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方应组织具有相应资格证书的工人（持证上岗率100%）投入工作，不得允许未获得相应资格证书的工人进入施工现场</span
          ><span style="font-size: 16px; font-family: 宋体"
            >；未经甲方授权或允许，不得擅自与发包人及有关部门建立工作联系；自觉遵守法律法规及有关规章制度。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">9.8 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >严格按照设计图纸、施工规范、有关技术要求及施工组织设计精心组织施工，确保工程质量达到约定的标准和等级；科学安排作业计划，投入足够的人力，机械设备，保证工期；加强安全教育，认真执行安全技术规范，严格遵守安全制度，落实安全措施，确保施工安全；加强现场管理，严格执行建设主管部门及环保、消防、环卫等有关部门对施工现场的管理规定，做到文明施工；承担由于自身责任造成的质量修理、返工、工期拖延、生产安全事故、现场脏乱、环境污染等造成的损失及各种罚款。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">9.9 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >自觉接受甲方及有关部门的管理、监督和检查；接受甲方随时检查其设备、材料保管、使用情况及其操作人员的有效证件、持证上岗情况；与现场其他单位协调配合，照顾全局。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">9.10 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >按甲方统一规划放置设备、堆放材料、机具，按甲方标准化工地要求设置标牌、统一着装，搞好生活区的管理，做好自身责任区的安保工作；若甲方或发包人要求乙方须在施工现场与甲方统一服装、安全帽、安全警示牌、宣传标识牌、使用甲方的统一形象标志时，乙方要无条件执行并负责其费用。另外，乙方应提供满足规定要求的劳动保护用品给其生产作业人员使用。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">9.11 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >做好施工场地周围建筑物、构筑物、地下管线和已完工程部分的成品保护工作，因乙方责任发生损坏、灭失，乙方自行承担由此引起的一切法律、经济责任及各种罚款。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">9.12 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >妥善保管、合理使用甲方提供或租赁给乙方使用的机具、周转资料及其他设施，归还甲方时如有损坏或丢失，乙方负责修复或按新购市场价格赔偿，并在结算中进行扣减。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">9.13</span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方自带施工机具、周转材料应满足施工需要，并应符合安全标准要求，在进场施工前应经甲方检查认可；乙方自带施工机具、周转材料的损坏和维修、保养、完善、提高费用及由此造成的停工损失，由乙方自行承担。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">9.14 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方须服从甲方转发的发包人及工程师的指令，并应在指令的期间内完成施工。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">9.15 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >除非本合同另有约定，乙方应对其作业内容的实施、完工负责，乙方应承担并履行总包合同约定的、与劳务工程有关的所有义务及工作程序。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">9.16 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方对外的一切经济活动均不能用甲方的名义进行运作或提供任何形式的经济担保。乙方在施工中的劳动用工以及材料采购等均应以乙方名义对外，乙方在施工中因管理的需要而刻制的印章图文不得与甲方刻制的印章图文雷同或相似，并需在甲方处备案。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">9.17 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方应妥善管理其劳动用工，处理好其与物资供货商、服务供应商以及其他人等的关系，不得出现其用工或供货商等直</span
          ><span style="font-size: 16px; font-family: 宋体"
            >接向甲方索要劳动报酬、材料款或其他款项等情况。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">9.18 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方应对农民工劳动用工实名制管理，按月足额向其所雇用的农民工发放工资，并于次月10日前将上月所雇用的农民工名册及农民工签领工资凭证交到甲方备案。</span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方收到劳务合同价款后首先支付工人劳动报酬。乙方保证与施工管理、作业人员签订有书面劳动合同，并每月向甲方提供上月本企业在本项目上所有施工管理、作业人员的劳动合同签署情况、出勤情况及工资核算及支付情况的盖章书面记录。除此书面记录的用工行为外，乙方承诺在本项目不存在其他用工行为。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">9.19 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方已经就合同所涉及的工程、相关的法律法规、技术规范以及与本合同相关的其他事项有充分的理解，乙方不得因为施工过程中各种文件、计划、措施、方法等的使用、履行得到甲方的同意、批准、认可、备案、审查、允许等而免除责任，甲方也不因为对这些文件、计划、措施、方法等的同意、批准、认可、备案、审查、允许等而承担责任。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">9.20 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >若乙方在执行合同过程中因乙方原因导致甲方被发包人或其他政府部门扣罚履约保证金或其它行政处罚时，乙方在此同意甲方有权从支付给乙方的工程款中扣除此费用，并有权要求乙方及时整改，若仍不能满足合同规定或发包人要求时，甲方有权终止合同，由此造成的损失责任由乙方负责。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">9.21 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方有义务搞好施工现场与其它承包商的配合协调关系，不得干扰或妨碍在施工现场的其它工程的正常施工，否则甲方有权采取制裁措施。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">9.22 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >因乙方或其雇员的原因造成自身、甲方或第三方的人身或财产损害（损失）的，乙方应承担责任。除因甲方原因造成的外，乙方在本劳务工程施工的过程中，应保障甲方免于承担任何人员的人身或财产损害（损失）的赔偿责任或其他形式的法律责任。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">9.23 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方承诺，在本合同有效期内，非经甲方书面同意，乙方不得将本合同项下的任何部分或全部权利或义务转让给任何第三人，否则视为乙方违约，甲方有权没收乙方履约保证金，并要求乙方向甲方支付合同总额<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 1cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="htAmount"
              >{{ detailForm.htAmount || "50" }}</span
            >%的违约金。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">9.24 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >劳务作业全部内容经验收合格后，乙方应当按照劳务劳务合同的约定及时将该劳务作业交付甲方，不得以双方存在争议为理由拒绝将该劳务作业交付甲方。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">9.25 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方在发现甲方存在未按照约定履行本合同行为时，应自发现之日起60日内书面告知甲方，未提出明确要求、逾期不行使告知权利的，视为放弃此项权利。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">9.26 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方应做的其他工作：</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">①</span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方严格按照交底和相关的操作规程进行施工，现场配备安全员，服从甲方管理。尤其夜间、雨季施工，做好安全工作。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >②乙方必须服从甲方对工程的进度和施工安排，尤其存在工序交叉作业时。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >③台风与冬季防护：根据目前的施工进度和自然环境的分析，甲乙双方约定：在台风和冬季大风来临前，甲方召开防护专题会议，出台防护措施并组织交底，乙方无条件按照该交底进行防护，防护完成后双方共同验收、确认。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >三、履约担保与保险</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp;<strong>10. </strong></span
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >履约担保</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp;10.1 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >本劳务合同是否采用履约担保：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 4cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="YorNlydb"
              >{{ detailForm.YorNlydb }}</span
            >&nbsp;（选填是或否）。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">10.2 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >甲乙双方约定采取履约担保，约定采用下列第<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 2cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="lydbType"
              >{{ detailForm.lydbType }}</span
            >种履约担保的方式，作为乙方全面、实际履行本工程施工合同的保证。履约担保的金额为合同总价的<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 1.5cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="zjhtRito"
              >{{ detailForm.zjhtRito }}</span
            >%（即<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 3cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="zjhtPrice"
              >{{ detailForm.zjhtPrice }}</span
            >元），履约担保金不计利息。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >（1）乙方在本工程施工合同签订之日起7日内，以现金的形式向甲方交纳履约担保金。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >（2）甲、乙双方约定，由甲方从支付给乙方的工程进度款中逐次按比例扣除款项作为履约担保金，直到履约担保金的金额达到双方约定的数额，甲方便不再扣除。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >（3）甲方认可或要求的银行出具的不可撤销的无条件追索保函。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">10.3 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >因乙方在施工过程中不能全面、实际的履行合同（中途私自退场，停工，拖欠（克扣）民工工资，非法用工，施工质量，安全、进度等不能满足甲方要求或合同规定的标准和要求，发生民工围攻、闹事、上访等事件时）造成甲方损失的，甲方将根据实际损失情况有权以乙方交纳的履约担保金的全部或部分作为赔偿；当甲方的损失超出乙方交纳的履约担保金金额时，甲方有权从乙方的工程款中（含进度款）继续扣足或留置乙方现场机械设备或通过其他途径获得赔偿。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">10.4 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >在施工过程中若因乙方原因导致履约担保金不足本合同约定的履约担保金数额时，乙方应足额向甲方补交履约担保金，或同意由甲方从支付给乙方的工程款中继续扣足履约担保金。履约担保金，在乙方工程完工验收合格，结算完毕，并在发包人退还甲方履约担保金后14天内，甲方退还给乙方（已作为赔偿甲方损失部分的除外）。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">10.5 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >甲方行使上述权利时，不以乙方同意为条件，只需书面通知乙方即可。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >11.
            </span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >保险</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">11.1 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方必须为从事危险作业的职工办理意外伤害保险，并为施工场地内自有人员生命财产和施工机械设备办理保险，支付保险费用。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">11.2 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >保险事故发生时，甲乙双方有责任采取必要的措施，防止或减少损失。若因乙方未能采取及时、有效的措施，致使损失进一步扩大而无法从保险公司获得赔偿时，则应承担由此造成的损失。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">11.3 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >若发生保险事故，乙方应积极主动配合甲方，及时提供有关保险理赔所需的有关资料、文件和证明，若因乙方资料、文件或证明保管不善或没有保存导致延误或失去保险理赔时，则由此造成的责任和损失由乙承担。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">11.4 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >甲方可随时检查乙方购买保险的情况，乙方需提供有关保险单据，不提供或提供不出的，甲方有权采取暂停支付进度款、从进度款中扣留相应部分代乙方购买保险等措施，乙方不得拒绝。甲方采取任何措施，不影响乙方应购买保险的责任。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >四、质量控制与材料、设备</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >12.
            </span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >质量控制</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">12.1 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >本合同工程质量应达到本合同协议书约定的质量标准，质量评定标准按总包合同相应条款履行。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">12.2 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >质量自检：本合同工程各分项工程、分部工程完成后，乙方应进行质量自检，质量自检不合格时应自行返工，因返工所发生的费用自行承担，延误的施工期不予顺延；自检合格后向甲方提交自检报告并通知甲方，甲方会同监理工程师进行验收。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">12.3 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >分项工程质量检查</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">12.3.1 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >主要分项工程开工前，乙方应将材料、设备和人员进场情况及施工工艺向甲方报告，经甲方同意后才能开工。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">12.3.2 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >上道工序施工完成，经甲方验收合格签认后，乙方才能进行下道工序的施工。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">12.3.3 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >在施工过程中，乙方应随时接受甲方和监理工程师及其委派人员对材料、工艺流程和操作的检查，并按甲方、监理工程师的指令进行返工。若因乙方原因造成返工和施工期延误，返工费用由乙方承担，施工期不予顺延；若因甲方的不正确指令，造成乙方经济损失或施工期延误，则有关费用由甲方承担，施工期相应顺延；若因监理工程师的不正确指令造成甲方、乙方经济损失或施工期延长，则乙方要密切配合甲方进行索赔。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">12.4 </span
          ><span style="font-size: 16px; font-family: 宋体">隐蔽工程验收</span>
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">12.4.1</span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方在自检合格并签署隐蔽工程自检记录提供隐蔽工程的照片后报甲方，由甲方组织验收，合格后方可进行一下步施工。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">12.4.2 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >若乙方未经验收而自行覆盖和继续施工，甲方、发包人和监理工程师有权要求剥离或开孔检查，由此造成的损失，由乙方负责，影响的工期不予顺延。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">12.4.3 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >若监理工程师认为确需对已签字验收或予以确认的、并覆盖的隐蔽工程进行复查，乙方应协助复查。若复查结果表明质量合格，因此而造成的一切损失，乙方应密切配合甲方进行索赔；若复查结果表明质量不合格，乙方应进行返工，并按上述规定重新申请验收，由此引起的一切费用由乙方承担，工期不予顺延。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">12.5 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >试验与检验：试样、试件应按技术标准的要求送到具备相应资质等级的检验单位进行试验或检验，并及时将试验或检验结果提交甲方审查。甲方或监理工程师认为必要时，有权指定取样送检验单位复检。甲方工地试验室免费为乙方提供基础实验。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >&nbsp;&nbsp;13.
            </span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >材料与设备</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">13.1 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >所有用于工程的材料、设备应有产品合格证书，工程材料应具备由具有相应资质等级的材料检验单位出具的材质证书或试验报告。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;text-indent: 32px;line-height: 37px;white-space: normal"
        >
          <span style="font-size: 16px; font-family: 宋体">13.2 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >甲供及乙供材料和设备进场时，乙方应通知甲方和监理工程师参加验收，甲方和监理工程师有权要求检验。对于设计和技术标准要求不符的材料和设备，甲方和监理工程师有权拒绝验收，并由供货方运离现场，或由甲方指定乙方运离施工现场相关费用由相关责任方承担；在材料使用和设备安装过程中，甲方和监理工程师有权随时复检，乙方应提供必要协助。若复检发现材料或设备不合格时，该批材料或设备不能用于本工程，乙方应负责拆除、修复及重新采购，费用由相关责任方承担，且工期不予顺延；若复检表明材料或设备符合要求，由乙方原因造成的应由乙方承担由此发生的一切费用，施工期是否相应顺延由甲方决定。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;text-indent: 32px;line-height: 37px;white-space: normal"
        >
          <span style="font-size: 16px; font-family: 宋体">13.3 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >甲供材料进场后，乙方不得将材料，半成品，成品等未经甲方同意擅自转移出场。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;text-indent: 32px;line-height: 37px;white-space: normal"
        >
          <span style="font-size: 16px; font-family: 宋体">13.4 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方的专职领料人员由乙方在专用条款中指定，乙方的结算以该人员的签字为准。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;text-indent: 32px;line-height: 37px;white-space: normal"
        >
          <span style="font-size: 16px; font-family: 宋体">13.5 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >甲方供应的材料和机械费用按约定如期进行结算扣除。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;text-indent: 32px;line-height: 37px;white-space: normal"
        >
          <span style="font-size: 16px; font-family: 宋体">13.6 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方进场设备必须符合施工要求，检验手续齐全，操作人员上岗证件真实合法，如出现安全问题，均有乙方负责。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;text-indent: 32px;line-height: 37px;white-space: normal"
        >
          <span style="font-size: 16px; font-family: 宋体">13.7</span
          ><span style="font-size: 16px; font-family: 宋体"
            >甲供材料有：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 12cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="jgcl"
              >{{ detailForm.jgcl }}</span
            > </span
          ><span style="font-size: 16px; font-family: 宋体">。</span>
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;text-indent: 32px;line-height: 37px;white-space: normal"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >五、施工期限</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >14.
            </span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >开工与延期开工</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >　　14.1
            乙方应当按照本合同约定的开工日期开工。乙方不能按时开工，应当不迟于本合同协议书约定的开工日期前5天，以书面形式向甲方提出延期开工的理由。甲方应当在接到延期开工申请后的48小时内以书面形式答复乙方。甲方在接到延期开工申请后48小时内不答复，视为同意乙方要求，工期相应顺延。甲方不同意延期要求或乙方未在规定时间内提出延期开工要求，工期不予顺延。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">14.2 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >因甲方原因不能按照本合同协议书约定的开工日期开工，甲方应以书面形式通知乙方，推迟开工日期。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体">15 </span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >暂停施工</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">15.1 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >因乙方原因，发包人或工程师认为确有必要暂停施工时，应以书面形式通过甲方向乙方发出暂停施工指令，并在提出要求后48小时内提出书面处理意见。因乙方原因造成的乙方停工和复工程序以及暂停施工所发生的费用，由乙方自行承担。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 33px;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >16.
            </span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >工程竣工</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">16.1 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方应按照本合同协议书约定的竣工日期或甲方同意顺延的工期竣工。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">16.2 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >因乙方原因不能按照本合同协议书约定的竣工日期或甲方同意顺延的工期竣工的，乙方承担违约责任。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >　　16.3 提前竣工程序按总包合同相应条款履行。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >六、安全施工、检查、防护及事故处理</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体">17.</span></strong
          >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >安全施工、检查、防护</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">17.1 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方须持有合法有效的《安全生产许可证》，并严格遵守《中华人民共和国安全生产法》、国务院《建设工程安全生产条例》等法律法规的规定，遵守国家和有关部门的安全管理规定；加强施工人员与机械的施工安全管理，对施工现场的防台、防火、防爆、防汛和防盗等采取严格的安全防护措施，严格遵照甲方现场的一切安全管理规定，保证施工现场文明施工。严格遵守国家相关临时用电规范的要求，强制采用三相五线的用电要求，并承担由于管理不力或技术措施不到位造成的事故责任和由此发生的费用；严格按安全标准进行施工，随时接受行业安全检查人员依法实施的监督检查，采取必要的安全防护措施，消除事故隐患。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">17.2 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方在动力设备、燃气管道、输电线路、地下管网、密封防震车间、易燃易爆地段以及临街交通要道附近施工时，施工开始前应做好安全措施或《安全施工专项方案》，确保第三方财产不受破坏，防护措施费用已包含在工程量清单的相关单价中，不再另计，因乙方原因导致的破坏由乙方负责。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">17.3 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方在施工现场应按要求统一配备合格的安全劳动保护用品（如安全帽、安全带及其他保护用品），若乙方不能按要求配备，则由甲方配备，由此增加的费用（包括但不限于安全劳动保护用品、甲方额外支出等）由乙方承担，在工程最终结算时从结算款中直接扣除。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">17.4 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方应根据合同约定或者法律法规的规定，提出安全施工计划或者安全保护措施。乙方不因为这些安全施工计划和安全保护措施是经由甲方同意、批准、备案的而免除责任，甲方也不因对这些安全施工计划和安全保护措施的同意、批准、备案而承担责任。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">17.5 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >预扣乙方合同价款的1%作为向甲方交纳安全生产风险抵押金。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">17.6 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >在签订本合同的同时，甲乙双方应按照本工程的实际情况另行签订安全环保协议书。安全环保协议书与本劳务合同约定有不一致的地方，以本劳务合同为准。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >18.
            </span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >事故处理</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">18.1 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >发生生产安全事故和环境污染事故，乙方应立即向甲方报告，由甲方按国家有关法律、行政法规对事故进行上报。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">18.2</span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方施工过程中造成人员伤亡及其他安全事故的，甲方有权将其已缴纳的安全风险抵押金（如果风险抵押金额不足的扣除相应工程款)进行处置，直到事故处理完毕，如果甲方因此遭受的损失，乙方应据实赔偿并承担相应法律责任。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">18.3 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >非甲方原因造成的人员伤亡及其他安全事故的，其责任和损失均由乙方承担。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >七、合同价款、计量方式、付款方式及税费</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >&nbsp;&nbsp;19.
            </span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >合同价款</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp;19.1 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >本合同采用<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 2cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="contractType"
              >{{ detailForm.contractType }}</span
            >合同。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">&nbsp;&nbsp;</span
          ><span style="font-size: 16px; font-family: 宋体"
            >单价为综合单价，不含税单价固定不变，税金随着国家规定税率的调整而调整，最终税金金额以开具发票时的国家税率计算为准。单价中已包含材料的损耗，单价中包括但不限于乙方根据施工现场条件按本合同约定的工期和技术质量、安全等要求实施并完成本工程所需的所有费用，包括但不限于企业安全生产费用、调遣费、人工费、除甲方提供外的一切材料费用及材料消耗、临时设施及税费(税率以乙方开具发票时国家规定税率为准，税金随着税率调整而调整)、利润、管理费、定额费、建管费、环保费、施工风险费、办理各种施工许可证的费用、保险费、政府收取的其它规费和所有其他可能发生的费用。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">&nbsp;&nbsp;</span
          ><span style="font-size: 16px; font-family: 宋体"
            >施工便道维护、环保（包含洒水）费用如清单中没有单独约定视为含在施工单价中，同时因赶工期发生的设备倒运、人员调遣、加大投入也含在相应施工单价中，施工中因雨排水、清理垃圾、整理场地等辅助措施不单计；产品成型检验、检测费用除清单单独约定外含在相应项目单价中。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >税费由甲方按本合同的规定，在收到乙方的增值税专用发票认证通过后不予扣除；若因甲方同意的特殊原因乙方没有按约定提供增值税专用发票而付款的情形，甲方按照付款金额的10%暂扣因未提供增值税专用发票而产生的税费，待乙方提供出可抵扣的增值税专用发票后，甲方将相应的暂扣税费还给乙方。否则，甲方可以拒绝付款，引发的经济纠纷及法律纠纷由乙方承担。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >单价中包含按施工图纸、工程规范要求完成的一切工作内容<strong>，</strong>包括但不限于机械设备、人员进出场、临时用地、生活临时设施、水电、饮食、交通等费用（包括燃油）、人工费、相应材料损耗、税费等费用。单价为固定单价，不随本合同约定的工程数量变化、燃油、物价等各种市场因素的影响而调整，也不因材料的损耗等施工因素而进行调整。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >工程价款实行单价承包，工程量按实际发生数量经甲方项目部工程部门、计量部门、技术负责人、项目经理共同签认的结算确认单（所有与工程有关的单证必须有项目经理的签字原件，双方约定无项目经理签字原件为无效确认单）报甲方职能小组审核同意为准，工程数量如因甲方项目部安排增加超出计量红线数量，须由项目部提前上报甲方核算小组审批，原则上不能超过发包方经国家审计部门审计、对甲方的支付数量。增加工程项目，需补充清单，单价按甲方内部指导单价确定，由甲方项目部及乙方签字确认，报甲方核算小组同意后补入合同。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >20.
            </span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >付款方式</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">20.1 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >进度款：按月支付，甲方根据发包人支付给甲方的进度款扣除主材后，按&nbsp;
            85
            %的比例再扣除以下款项后支付给乙方（即月进度款最高付款限额为月进度款<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 2cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="monthReto"
              >{{ detailForm.monthReto }}</span
            >，支付前乙方应向甲方提供与支付等额的增值税专用发票）：</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >（1）工程保修金
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 1.5cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="gcbxj"
              >{{ detailForm.gcbxj }}</span
            >；</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >（2）履约保证金
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 1.5cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="lybzj"
              >{{ detailForm.lybzj }}</span
            >；</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >（3）扣留完成合同价款的
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 1.5cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="zjbzj"
              >{{ detailForm.zjbzj }}</span
            >%作为质量保证金；</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >（4）预扣合同价款的
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 1.5cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="fxdyj"
              >{{ detailForm.fxdyj }}</span
            >%作为安全生产风险抵押金；</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >（5）甲方代乙方缴纳或支付的税金及其它有关费用；</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >（6）甲供主材数量以材料部领取双方签字的数量为依据，按照双方签字认可的数量扣除。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >（7）乙方的工程数量中包含乙方未进场时，其他单位完成的部分工程量，该数量以项目部签证为准。第一期计量支付时从乙方计量款中予以扣除。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >（8）其它赔偿金或其它应扣留或扣除的费用。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">20.2 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方每月 22
            日前向甲方提交由监理人确认的当月完成工程量资料，如果乙方不能提供计量资料造成无法计量时，乙方无权要求甲方支付工程款。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >乙方每月根据甲方与发包方的计量支付，进行中间付款前的中期结算，结算格式按甲方规定，项目部签字齐全后作为付款审核的依据。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">20.3 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >本合同工程款的支付作为附条件民事法律行为（即甲方支付乙方某期工程款须以发包人支付甲方相应时期工程款为前提和条件）。当条件成就（即发包人向支付工程款）时，甲方根据本合同的规定向乙方支付工程款；当条件不成就（即发包人尚未向甲方支付工程款）时，甲方也相应延期向乙方支付工程款。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">20.4 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >当甲方累计付款达到双方约定的数额时，甲方停止付款。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">20.5 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方应保证所收到的进度款全部用于该工程的施工需要，甲方有权对乙方的工程款使用情况进行检查、监督。乙方应为甲方提供检查、监督的有关资料、文件，并提供必要的便利和条件。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">20.6 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >因特殊情况出现未开增值税发票的情形，结算税费由甲方按本合同的规定，在应付给乙方的款项中按10%给予暂扣，乙方应当持依法取得的相应施工资质证书，按《建筑法》、《中华人民共和国发票管理办法》规定及时提供符合税法规定的真实增值税专用发票，最终结算时，按本合同约定退还暂扣税费。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >八、施工变更</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体">21</span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >．施工变更</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">21.1</span
          ><span style="font-size: 16px; font-family: 宋体"
            >施工中乙方不得自行对原工程设计进行变更。因乙方擅自变更设计发生的费用和由此导致甲方的损失，由乙方承担，延误的工期不予顺延。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >九、施工验收与结算</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >22.
            </span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >施工验收</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">22.1 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方应确保所完成施工的质量，符合本合同约定的质量标准。乙方施工完毕，应向甲方提交完工报告，通知甲方验收；甲方应当在收到乙方的上述报告后进行完工检查，完工检查合格后及时报请发包人和监理工程师对乙方施工成果进行验收，验收合格，视为乙方所完成工程符合质量要求的初步证明。但甲方与发包人间的隐蔽工程验收结果或工程竣工验收结果表明乙方施工质量不合格时，乙方应负责无偿修复，且工期不予顺延，并承担由此给甲方造成的所有经济损失。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">22.2 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >工程交工验收合格后，除甲方另有要求外，乙方应在3日内清理并撤离施工现场。乙方未按要求及时撤离的，甲方有权委托第三人对乙方及其设备、材料、人员等进行清场，所产生的费用由乙方承担，并在甲方应支付给乙方的工程款中进行抵扣，不足部分，乙方应予以赔偿。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">22.3 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >交工验收合格后，乙方应在15天内向甲方提交以月签字工程量汇总的结算报告。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">22.4</span
          ><span style="font-size: 16px; font-family: 宋体">竣工资料：</span>
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >（1）竣工资料提交的时间：
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 3cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="tjsj"
              >{{ detailForm.tjsj }}</span
            >。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >（2）竣工资料提交的份数：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 3cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="tjfs"
              >{{ detailForm.tjfs }}</span
            >。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >（3）竣工资料基础资料由乙方提供并办理相关手续，竣工资料由甲方编制。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >&nbsp;&nbsp; 22.5 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >工程尾款应在甲方完成审计，资金批复后支付。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >23.
            </span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >结算</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">23.1</span
          ><span style="font-size: 16px; font-family: 宋体"
            >本合同履行过程中，乙方应按照国家有关标准、发包人或甲方要求及时收集、整理有效的施工资料（包括但不限于：交工验收、竣工验收、工程结算资料），在工程完工后及时向甲方提供竣工验收、工程结算资料。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">23.2 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >若因乙方未遵守国家有关标准和甲方要求及时向甲方提供合法有效的交工验收、竣工验收、工程结算资料，影响甲方办理工程交工、竣工验收及工程结算时，所造成的责任均由乙方承担。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">23.3 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >本合同工程的结算，由甲方授权委托的项目现场代表签字或盖章确认核实，但该签字或盖章确认核实只能作为双方结算的初步的、预计的确认，不能作为乙方向甲方请求支付或双方最终结算的依据。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">23.4 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >工程结算经双方核定后，报甲方审计，</span
          ><span style="font-size: 16px; font-family: 宋体"
            >最终结算须经甲方主管部门审核，以甲方主管部门的审核作为工程的最终结算，在甲方主管部门签字盖章后方能生效。否则，除非获得甲方书面确认，任何甲方项目部或部门及任何形式的最终结算均对甲方不具有任何法律约束力。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">23.5 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >当工程合同时间终止，或乙方承担的工程完工后二个月，如甲方通知乙方办理结算，乙方应在接到通知后15天内与甲方办理结算，乙方未按甲方通知的要求在规定的时间内与甲方办理结算，则可推定乙方同意甲方所作出的结算为最终的结算。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >十、工程保修</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >24.
            </span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >工程保修</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">24.1 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >保修期限：执行总包合同。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">24.2 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >保修范围：本合同约定的乙方施工的所有内容。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">24.3 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >保修责任：乙方在工程保修期内有责任返修因乙方原因造成的任何工程缺陷或损坏，返修费用由乙方承担。需要返修的，乙方应在接到返修通知后14天内开始返修，并在甲乙双方商定的时间内修理完毕，否则甲方有权委托其他单位或人员进行修理，其费用由乙方承担。但乙方在工程设计使用年限内的保修责任不因保修期满或甲方已返还保修金而免除。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">24.4 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >质保金数额、是否计息及返还时间：质保金为合同总价3%，当合同约定保修期满且无任何质量缺陷，业主支付给甲方全额质保金30天内，甲方无息返还乙方质保金。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >十一、争议、违约、索赔与赔偿</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >25.
            </span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >争议</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">25.1</span
          ><span style="font-size: 16px; font-family: 宋体"
            >双方在执行合同过程中发生争议时，应协商解决；协商不成的，任何一方均应向甲方所在地人民法院起诉，因解决争议而产生的所有费用，包括但不限于诉讼费、律师费、评估费、鉴定费、审计费、差旅费等均由乙方承担。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">25.2 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >争议发生后，除双方均同意停工外，双方都应继续履行合同，否则视为违约。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >26.
            </span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >违约、赔偿</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">26.1 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >任何一方不按合同履行自己的责任和义务，均为违约。违约方应按合同条款的约定向对方支付违约金并赔偿因违约给对方造成的直接经济损失。因一方违约使合同不能履行时，另一方可要求中止或解除合同，但应提前14天通知违约方，由此造成的经济损失由违约方承担。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">26.2 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方施工质量不符合本合同约定的质量标准，甲方有权要求乙方返工，返工费用由乙方承担，施工期不予顺延；若返工后仍达不到约定等级，甲方有权直接委托第三方进行施工或要求乙方须继续履行合同，直至达到约定等级，若甲方委托第三方进行施工所产生的费用全部由乙方承担，由甲方在应向乙方支付的工程款中扣除，不足的乙方应在接到甲方通知之日起三日内一次性向甲方支付。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 31px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">26.3 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方不能按时、保质保量完成本劳务合同约定的节点工期的，甲方有权选择将部分工程另行委托其它承包商完成或解除本劳务合同，甲方将按乙方实际完成且经验收合格的工程量给乙方办理结算，但要相应扣除由乙方违约而给甲方造成的损失（包括但不限于可能引起的发包人对甲方的罚款、由于甲方雇佣另外的劳务商所增加的费用、因赶工期需要而增加的工程投入以及因此而导致甲方其他费用的增加）。如甲方的损失无法计算，则甲方可扣减乙方已完工作量的20％作为损失补偿。因乙方自身原因造成延期交工的，每延误一日，应向甲方支付
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 2cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="wyj"
              >{{ detailForm.wyj }}</span
            >元违约金。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">26.4 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方施工质量不符合本合同约定的质量标准，甲方有权要求乙方返工，返工费用由乙方承担，施工期不予顺延；若返工后仍达不到约定等级，则乙方应向甲方支付
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 2cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="wyj1"
              >{{ detailForm.wyj1 }}</span
            >元违约金，此外，乙方还应承担由此给甲方造成的相应损失；若因发包方或监理工程师原因，致使工程质量达不到约定等级，乙方应密切配合甲方进行索赔；若因甲方原因使工程质量达不到约定等级，乙方应根据甲方要求进行返工或修整，甲方承担返工与修整费用，并相应顺延施工期。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">26.5 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >因乙方未及时支付材料费、设备购置或租赁费等给本工程或甲方造成损失的，视为乙方违约，每违约一次应向甲方支付
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 2cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="wyj2"
              >{{ detailForm.wyj2 }}</span
            >元违约金。同时甲方有权采取扣除乙方工程款的方式进行代为支付，因代为支付材料费、设备购置或租赁费造成乙方工程进度款支付延迟的，甲方不承担任何责任。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">26.6 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >由于乙方管理漏洞、施工不当而给甲方造成的任何损失应由乙方承担。乙方不履行或不按约定履行合同的其他义务时，每违约一次应向甲方支付
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 2cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="wyj3"
              >{{ detailForm.wyj3 }}</span
            >元违约金。乙方还应赔偿因其违约给甲方造成的经济损失，延误的乙方工作时间不予顺延。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">26.7 </span
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >乙方劳务的工程项目不得再行劳务分包或转包。</span
            ></strong
          ><span style="font-size: 16px; font-family: 宋体"
            >若乙方将工程项目进行再次劳务分包或转包，甲方有权随时解除合同，并收取本合同价款的50%作为违约金。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">26.8 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方未按照《企业安全生产费用提取和使用管理办法》的规定使用安全费用的，则由乙方自行承担由此引起的一切责任（包括但不限于安全事故责任、给第三人的财产或人身造成的损失、其他事故责任）。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">26.9 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方未按照《企业安全生产费用提取和使用管理办法》的规定使用安全费用的，甲方可暂停支付乙方工程款，待乙方整改或赔偿由此引起的损失后再予以支付。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="margin: 0 3px 15px;font-size: 16px;font-family: &#39;Arial Unicode MS&#39;, sans-serif;white-space: normal;text-indent: 30px;line-height: 37px"
        >
          <span style="font-family: 宋体">26.10 </span
          ><span style="font-family: 宋体"
            >过程管理中参照以下规定约定违约金：</span
          >
        </p>
        <p
          class="contract_word_p"
          style="margin: 0 3px 15px;font-size: 16px;font-family: &#39;Arial Unicode MS&#39;, sans-serif;white-space: normal;text-indent: 30px;line-height: 37px"
        >
          <span style="font-family: 宋体">26.10.1 </span
          ><span style="font-family: 宋体"
            >《中华人民共和国民法典》第五百八十五条规定：“当事人可以约定一方违约时应当根据违约情况向对方支付一定数额的违约金，也可以约定因违约产生的损失赔偿额的计算方法。约定的违约金低于造成的损失的，人民法院或者仲裁机构可以根据当事人的请求予以增加；约定的违约金过分高于造成的损失的，人民法院或者仲裁机构可以根据当事人的请求予以适当减少。当事人就迟延履行约定违约金的，违约方支付违约金后，还应当履行债务。”</span
          >
        </p>
        <p
          class="contract_word_p"
          style="margin: 0 3px 15px;font-size: 16px;font-family: &#39;Arial Unicode MS&#39;, sans-serif;white-space: normal;text-indent: 30px;line-height: 37px"
        >
          <span style="font-family: 宋体">26.10.2 </span
          ><span style="font-family: 宋体"
            >当事人主张约定的违约金过高请求予以适当减少的，应当以实际损失为基础，兼顾合同的履行情况、当事人的过错程度以及预期利益等综合因素，根据公平原则和诚实信用原则予以提出。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="margin: 0 3px 15px;font-size: 16px;font-family: &#39;Arial Unicode MS&#39;, sans-serif;white-space: normal;text-indent: 30px;line-height: 37px"
        >
          <span style="font-family: 宋体">26.10.3 </span
          ><span style="font-family: 宋体"
            >当事人约定的违约金超过造成损失的百分之三十的，一般可以认定为民法典第五百八十五条第二款规定的“过分高于造成的损失”。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="margin: 0 3px 15px;font-size: 16px;font-family: &#39;Arial Unicode MS&#39;, sans-serif;white-space: normal;text-indent: 30px;line-height: 37px"
        >
          <span style="font-family: 宋体">26.1</span
          ><span style="font-family: 宋体">1 </span
          >若乙方能够按照甲方计划按要求完成任务，甲方将按照以上单价给乙方结算，否则甲方将所有单价按原定单价的<span
            style="font-family: 宋体"
            >70%</span
          >给乙方结算<span style="font-family: 宋体">。</span>
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">26.12 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >如经发现乙方对本工程不具备施工能力或者工程进度、质量不能满足要求（双方约定由甲方项目经理、副经理、总工、计划部长中三人以上共同签字确认）甲方则有权随时调整乙方工作任务。或者终止合同、并通知乙方在限期内出场。施工中，若因施工质量、进度等问题监理工程师给乙方所施工工程下达了《监理指令》或《停工通知》，第一次甲方提出警告，第二次甲方将扣除乙方壹万元，第三次甲方将视为乙方无能力完成该项工程施工，有权解除本合同，另行组织劳务队伍施工。清场后按照完成合格工程量的90%结算。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >27.
            </span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >索赔与赔偿</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">27.1 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >因乙方所施工工程导致乙方向甲方索赔时，乙方须在事情发生后3日内向甲方提出索赔申请，甲方应积极向工程发包人进行相同的索赔，乙方予以全力配合。乙方从甲方获得的任何赔偿额，不得高于因相同事项、原因甲方从发包人获得的赔偿额。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >十二、不可抗力</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >28.
            </span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >不可抗力</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">28.1 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >本合同中不可抗力的定义与总包合同中的定义相同。双方关于不可抗力约定的参照标准：
            五级以上地震；大于等于6级持续4小时以上的大风；150mm以上的雨雪；10年来未发生的洪水、高温、高寒天气（以当地有关部门发布的灾情报告为准）。自然引起的不可抗力，承包人应出具地震及气象部门的灾情报告。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">28.2 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >不可抗力事件发生后，乙方应立即通知甲方项目经理，并在力所能及的条件下迅速采取措施，尽力减少损失，甲方应协助乙方采取措施。甲方项目经理认为乙方应当暂停工作，乙方应暂停工作。不可抗力事件结束后48小时内乙方向甲方项目经理通报受害情况和损失情况，及预计清理和修复的费用。不可抗力事件持续发生，乙方应每隔7天向甲方项目经理书面通报一次受害情况。不可抗力结束后14天内，乙方应向甲方项目经理提交清理和修复费用的正式报告和有关资料。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">28.3 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >因不可抗力事件导致的费用和延误的工作时间由双方按以下办法分别承担：</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >（1）人员伤亡由其所属单位负责；</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >（2）乙方设备、机械的损坏由乙方承担；</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >（3）甲方提供给乙方使用的机械设备损坏，由乙方承担，停工损失由乙方自行承担；</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">28.4 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >因合同一方迟延履行合同后发生不可抗力的，不能免除迟延履行方的相应责任。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >十三、文物和地下障碍物</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >29.
            </span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >文物和地下障碍物</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">29.1 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >在施工中发现古墓、古建筑遗址等文物和化石或其他有考古、地质研究价值的物品时，乙方应立即保护好现场并于4小时内以书面形式通知甲方，甲方应于收到书面通知后24小时内报告当地文物管理部门，甲方和乙方按文物管理部门的要求采取妥善保护措施。如乙方发现后隐瞒不报、哄抢文物或占有文物，致使文物遭受破坏，责任者依法承担相应责任，给甲方造成损失的，乙方应赔偿。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">29.2 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >施工中发现影响工作的地下障碍物时，应确保不进行破坏，乙方应于8小时内以书面形式通知甲方，同时提出处置方案，甲方收到处置方案后24小时内予以认可或提出修改方案，由此发生的费用由甲乙双方平均分担，经向发包人或监理工程师索赔工期获许后顺延合同工作时间。所发现的地下障碍物有归属单位时，甲方应报请有关部门协同处置。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >十四、合同中止与解除</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >30.
            </span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >合同中止</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">30.1 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >由于政策的变化和其他甲、乙双方及发包人之外的特殊原因导致工程停建或缓建，使合同不能继续履行，即视为合同中止。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">30.1.1 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >合同中止后，乙方应妥善做好已完工程、现场机械设备、材料等的保护和工程的移交工作；按照甲方或建设单位要求将自有机械设备和人员等撤离施工现场。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">30.1.2 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >合同中止或暂停施工后，乙方必须按照甲方的指示暂停施工或复工；因合同中止造成的损失，在甲方得到发包人赔偿的前提下，甲方根据乙方具体情况酌情予以补偿。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">30.2 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >在本合同工程施工过程中，不可抗力包括的范围以及事件处理按总包合同相应条款执行。不可抗力事件发生涉及乙方施工场地的，乙方应立即通知甲方，在力所能及的条件下，迅速采取措施，尽力减少损失。发生不可抗力后，乙方承担自身的人员和财产的损失。但若因合同一方延迟履行合同后发生不可抗力的，则不能免除延迟履行方的相应责任。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >31.
            </span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >合同解除</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">31.1 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >如在乙方没有完全履行本合同义务之前，由于非甲乙双方原因造成合同撤销和解除，甲方应通知乙方终止或解除本合同，乙方承诺不以此理由向甲方提出任何索赔。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">31.2 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方违反本合同约定导致工期延误的，经甲方要求仍不采取措施赶工的，或工期拖延（包括节点工期）达达<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 1cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="gqDelay"
              >{{ detailForm.gqDelay || "7" }}</span
            >天的，甲方可以解除合同。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">31.3 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方将本合同的工程内容进行转包或再次劳务的，甲方可以解除合同。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">31.4 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >合同解除后，乙方应妥善做好已完工程移交和撤场工作。乙方在接到甲方撤场通知后3日内撤离现场，甲方应为乙方撤出提供必要条件，工程款支付按本合同的约定进行。乙方未及时撤场的，甲方可委托第三人进行场地清理，发生的费用从甲方应支付给乙方的工程款中扣除。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">31.5 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >除30.1款约定的情形外，违约方应当赔偿因合同解除给对方造成的损失。合同解除后，不影响双方在合同中约定的结算和清理条款的效力。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">31.6 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >合同解除的其它事宜：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 12cm;
                text-indent: 5px;
                padding-bottom: 2px;
                line-height: 32px;
                word-break: break-all;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="jchtqtsy"
              >{{ detailForm.jchtqtsy }}</span
            ></span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >十五、环境保护与文明施工</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">32.</span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方应按照甲方环境管理体系要求建立健全环境保护体系，在施工区域内要保护当地自然环境，遵守国家级地方有关环保与职业病防治的法律法规，按各项规章制度要求进行环境保护工作。要采取合理的环境保护措施，做到不污染环境，不破坏树木、草地等。如造成环境污染损失，由乙方自行承担责任。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">33.</span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方在施工全过程贯穿“节约能源，降低物耗”的管理思想并厉行节约，降低施工噪声，避免噪声扰民事件的发生，保证施工扬尘、废水、废物的排放符合规定标准，杜绝发生较大环境污染事件，减少一般环境污染事件，实现社区居民无重大投诉。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">34.</span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方应按甲方的企业文化总体要求，规划和统一项目的标识、标牌，规范项目员工的行为，贯彻和落实甲方的各项管理制度和办法。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">35.</span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方应按甲方统一规划堆放材料、机具，按甲方标准化工地要求设置标牌，做好生活区的管理工作，做好自身责任区的清洁卫生和治安保卫工作。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">36.</span
          ><span style="font-size: 16px; font-family: 宋体"
            >乙方应自行恢复临时用地、自行处理施工垃圾和生活垃圾，费用由乙方自行承担。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >十六、其他条款</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <strong
            ><span style="font-size: 16px; font-family: 宋体"
              >37.
            </span></strong
          ><strong
            ><span style="font-size: 16px; font-family: 宋体"
              >其他条款</span
            ></strong
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">37.1 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >重大信息及时通知条款<strong>。</strong></span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体"
            >如乙方在执行合同过程中，涉及重大信息变更，如税务登记证变更、公司名称变更、银行账户变更等，应在3日内及时向甲方告知具体的变更情况，并提供相关纸质或电子信息资料。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">37.2 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >双方履行完本合同义务，工程价款支付完毕，乙方向甲方交付所施工的工程项目，并经发包人、甲方共同验收合格后，质保期满且质保金给付完毕，本合同即告终止。</span
          >
        </p>
        <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;text-indent: 32px;line-height: 37px"
        >
          <span style="font-size: 16px; font-family: 宋体">37.3 </span
          ><span style="font-size: 16px; font-family: 宋体"
            >合同份数：本合同一式<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 2cm;
                text-align: center;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="contractNum"
              >{{ detailForm.contractNum }}</span
            >份，具有同等效力，甲方执<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 2cm;
                text-align: center;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="contractNumA"
              >{{ detailForm.contractNumA }}</span
            >份，乙方执<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 2cm;
                text-align: center;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="contractNumB"
              >{{ detailForm.contractNumB }}</span
            >份。</span
          >
        </p>
        <p
          class="contract_word_p"
          style="
            font-size: 14px;
            text-align: justify;
            white-space: normal;
            line-height: 33px;
          "
        >
          <span style="font-size: 16px; font-family: 宋体">&nbsp;&nbsp;</span
          ><span style="font-size: 16px; font-family: 宋体">补充条款：</span>
        </p>
        <p
          class="contract_word_p"
          style="
            font-size: 16px;
            font-family: 宋体;
            text-align: justify;
            white-space: normal;
            line-height: 33px;
          "
        >
          <span
            style="
              outline: 0;
              text-indent: 5px;
              display: block;
              max-width: 776px;
              text-decoration: underline;
              white-space: pre-line;
            "
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="addContent"
            >{{ detailForm.addContent || "无。" }}</span
          >
        </p>
        <!-- <p
          class="contract_word_p"
          style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: justify;white-space: normal;line-height: 33px"
        >
          <strong>&nbsp;</strong>
        </p>
        <p class="contract_word_p"><br /></p>--> 
        </div> <!--for second-part-->
      </div>
    </div>
    <div class="printWrap" v-show="false">
      <div
        v-html="laborContractContent"
        class="mainHtml"
        id="printLaborContractContent"
      ></div>
    </div>
    <setWatermarkDialog
      ref="setWatermarking"
      @setWaterMarkFun="setWaterMarkFun"
    ></setWatermarkDialog>
  </div>
</template>

<script>
import {
  getServiceContractDetailService, //获取合同填充内容
} from "@/services/allContractServices";
import printJS from "print-js";
import {mixins} from '@/page/contract/template/mixin.js';
import { addPageNum } from "./common.js";
import { addPageNumCustom } from "./common.js";
// import { genWaterMark } from "@/common/warterMark";
import setWatermarkDialog from "../commonCell/setWatermarkDialog.vue";

export default {
  name: "LaborContract",
  components: {
    setWatermarkDialog,
  },
  mixins: [mixins],
  data() {
    return {
      laborContractContent: "", //富文本编辑器内容
      watermark: [""],
      saveflag: false,    
      detailForm: {
        serialNumber: " ",
        partyA: " ",
        partyB: " ",
        projectName: " ",
        signPlace: " ",
        xysContractNum: " ",
        fbr: " ",
        sgzcbxy: " ",
        shxydm: " ",
        zczj: " ",
        zczj1: " ",
        gcmc: " ",
        gcdd: " ",
        zhff: " ",
        kgrqYear: " ",
        kgrqMonth: " ",
        kgrqDay: " ",
        jgrqYear: " ",
        jgrqMonth: " ",
        jgrqDay: " ",
        htgqHoleDay: " ",
        hszjDX: " ",
        hszjXJ: " ",
        bhsj: " ",
        sf: " ",
        zlbzssyd: " ",
        htdlYear: " ",
        htdlMonth: " ",
        htdlDay: " ",
        htdlAddress: " ",
        htPartA: "青岛路桥建设集团有限公司 (盖章)",
        fddbrOthers: " ",
        wtdlr: " ",
        phone: " ",
        email: " ",
        openBank: "交通银行青岛市北第一支行",
        account: "372005530018000087685",
        workAddress: "青岛市重庆南路15号",
        emailYB: "266011",
        htPartB: "",
        fddbrOthersB: " ",
        wtdlrB: " ",
        phoneB: " ",
        emailB: " ",
        openBankB: "",
        accountB: " ",
        workAddressB: "",
        emailYBB: " ",
        value1: " ",
        value2: "",
        bk1: " ",
        projectMsgerA: " ",
        workA: " ",
        cphoneA: " ",
        caddressA: " ",
        cemailA: " ",
        projectMsgerB: " ",
        workB: " ",
        cphoneB: " ",
        caddressB: " ",
        cemailB: " ",
        YorNlydb: "是",
        lydbType: " ",
        zjhtRito: "10",
        zjhtPrice: " ",
        jgcl: " ",
        contractType: "单价",
        gcbxj: "/",
        lybzj: "10%",
        zjbzj: "3",
        fxdyj: "1",
        tjsj: "执行总包合同",
        tjfs: "执行总包合同",
        wyj: "5000",
        wyj1: "100000",
        wyj2: "100000",
        wyj3: "100000",
        contractNum: " ",
        contractNumA: " ",
        contractNumB: " ",
        addContent: " ",
        monthReto: " ",
        jchtqtsy:
          "乙方施工进度和施工质量及配备的相关专业施工人员、设备等不能满足甲方的施工需要，甲方有权单方面解除合同并追究乙方的责任。",
      },
      inputPages: "",
      inputHeight: 1010,
      inputPosx: 37,
    };
  },
  methods: {
    //获取一条劳务合同信息
    getsubServiceContractDetail(id) {
      if (!id) return;
      let param = {};
      param.id = id;
      getServiceContractDetailService(param)
        .then((res) => {
          if (res.code == 10000000) {
            let data = {};
            if (res.data.subContractPrintVO) {
              data = res.data.subContractPrintVO;
              this.watermark = res.data.subContractPrintVO.watermark || [""];
              if (data.content) {
                this.saveflag = true;
                let oj = JSON.parse(data.content);
                this.detailForm =  Object.assign({},oj );
                if (this.detailForm.bk2) {
                  this.detailForm.bk1 =
                    this.detailForm.bk1 +
                    this.detailForm.bk2 +
                    (this.detailForm.bk3 || "");
                }
                if (this.detailForm.jchtqtsy1) {
                  this.detailForm.jchtqtsy =
                    this.detailForm.jchtqtsy + this.detailForm.jchtqtsy1;
                }
                if (this.detailForm.zczj2) {
                  this.detailForm.zczj1 =
                    this.detailForm.zczj1 + this.detailForm.zczj2;
                }
                if (this.detailForm.zczj3) {
                  this.detailForm.zczj1 =
                    this.detailForm.zczj1 + this.detailForm.zczj3;
                }
                
              } else {
                this.detailForm = {
                  serialNumber: " ",
                  partyA: " ",
                  partyB: " ",
                  projectName: " ",
                  signPlace: " ",
                  xysContractNum: " ",
                  fbr: " ",
                  sgzcbxy: " ",
                  shxydm: " ",
                  zczj: " ",
                  zczj1: " ",
                  gcmc: " ",
                  gcdd: " ",
                  zhff: " ",
                  kgrqYear: " ",
                  kgrqMonth: " ",
                  kgrqDay: " ",
                  jgrqYear: " ",
                  jgrqMonth: " ",
                  jgrqDay: " ",
                  htgqHoleDay: " ",
                  hszjDX: " ",
                  hszjXJ: " ",
                  bhsj: " ",
                  sf: " ",
                  zlbzssyd: " ",
                  htdlYear: " ",
                  htdlMonth: " ",
                  htdlDay: " ",
                  htdlAddress: " ",
                  htPartA: "青岛路桥建设集团有限公司 (盖章)",
                  fddbrOthers: " ",
                  wtdlr: " ",
                  phone: " ",
                  email: " ",
                  openBank: "交通银行青岛市北第一支行",
                  account: "372005530018000087685",
                  workAddress: "青岛市重庆南路15号",
                  emailYB: "266011",
                  htPartB: "",
                  fddbrOthersB: " ",
                  wtdlrB: " ",
                  phoneB: " ",
                  emailB: " ",
                  openBankB: "",
                  accountB: " ",
                  workAddressB: "",
                  emailYBB: " ",
                  value1: " ",
                  value2: "",
                  bk1: " ",
                  projectMsgerA: " ",
                  workA: " ",
                  cphoneA: " ",
                  caddressA: " ",
                  cemailA: " ",
                  projectMsgerB: " ",
                  workB: " ",
                  cphoneB: " ",
                  caddressB: " ",
                  cemailB: " ",
                  YorNlydb: "是",
                  lydbType: " ",
                  zjhtRito: "10",
                  zjhtPrice: " ",
                  jgcl: " ",
                  contractType: "单价",
                  gcbxj: "/",
                  lybzj: "10%",
                  zjbzj: "3",
                  fxdyj: "1",
                  tjsj: "执行总包合同",
                  tjfs: "执行总包合同",
                  wyj: "5000",
                  wyj1: "100000",
                  wyj2: "100000",
                  wyj3: "100000",
                  contractNum: " ",
                  contractNumA: " ",
                  contractNumB: " ",
                  addContent: " ",
                  monthReto: " ",
                  jchtqtsy:
                    "乙方施工进度和施工质量及配备的相关专业施工人员、设备等不能满足甲方的施工需要，甲方有权单方面解除合同并追究乙方的责任。",
                };
                this.detailForm = { ...this.detailForm, ...this.dialogForm };
              }
            }
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
          this.loading=false;
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
          this.loading=false;
        });
    },
    //保存当前合同
    saveContractA() {
      this.saveCommon('LaborContract');
    },
    getValues() {
      // let Id1 = document.getElementById("HTMLLaborContract");
      let Id = document.getElementsByClassName(this.printClass)[0];
      this.detailForm.serialNumber =
        Id.getElementsByClassName("serialNumber")[0].innerText.trim();
      Id.getElementsByClassName("serialNumber")[0].innerHTML =
        this.detailForm.serialNumber;
      this.detailForm.partyA =
        Id.getElementsByClassName("partyA")[0].innerText.trim();
      this.detailForm.partyB =
        Id.getElementsByClassName("partyB")[0].innerText.trim();
      this.detailForm.projectName =
        Id.getElementsByClassName("projectName")[0].innerText;
      this.detailForm.signPlace =
        Id.getElementsByClassName("signPlace")[0].innerText.trim();
      Id.getElementsByClassName("signPlace")[0].innerHTML =
        this.detailForm.signPlace;
      this.detailForm.signDate =
        Id.getElementsByClassName("signDate")[0].innerText.trim();
      Id.getElementsByClassName("signDate")[0].innerHTML =
        this.detailForm.signDate;

      this.detailForm.xysContractNum =
        Id.getElementsByClassName("xysContractNum")[0].innerText.trim();

      Id.getElementsByClassName("xysContractNum")[0].innerHTML =
        this.detailForm.xysContractNum;
      this.detailForm.fbr =
        Id.getElementsByClassName("fbr")[0].innerText.trim(); //发包人
      Id.getElementsByClassName("fbr")[0].innerHTML = this.detailForm.fbr;
      this.detailForm.sgzcbxy =
        Id.getElementsByClassName("sgzcbxy")[0].innerText.trim(); //施工总承包协议
      Id.getElementsByClassName("sgzcbxy")[0].innerHTML =
        this.detailForm.sgzcbxy;
      this.detailForm.shxydm =
        Id.getElementsByClassName("shxydm")[0].innerText.trim(); //统一信用代码
      Id.getElementsByClassName("shxydm")[0].innerHTML = this.detailForm.shxydm;

      this.detailForm.zczj =
        Id.getElementsByClassName("zczj")[0].innerText.trim(); //经营范围
      this.detailForm.zczj1 =
        Id.getElementsByClassName("zczj1")[0].innerText.trim(); //经营范围
      this.detailForm.gcmc =
        Id.getElementsByClassName("gcmc")[0].innerText.trim(); //工程名称
      this.detailForm.gcdd =
        Id.getElementsByClassName("gcdd")[0].innerText.trim(); //工程地点
      this.detailForm.zhff =
        Id.getElementsByClassName("zhff")[0].innerText.trim(); //桩号范围
      Id.getElementsByClassName("zczj")[0].innerHTML = this.detailForm.zczj;
      Id.getElementsByClassName("zczj1")[0].innerHTML = this.detailForm.zczj1;
      Id.getElementsByClassName("gcmc")[0].innerHTML = this.detailForm.gcmc;
      Id.getElementsByClassName("gcdd")[0].innerHTML = this.detailForm.gcdd;
      Id.getElementsByClassName("zhff")[0].innerHTML = this.detailForm.zhff;

      this.detailForm.kgrqYear =
        Id.getElementsByClassName("kgrqYear")[0].innerText.trim(); //开工时间年
      this.detailForm.kgrqMonth =
        Id.getElementsByClassName("kgrqMonth")[0].innerText.trim(); //开工时间月
      this.detailForm.kgrqDay =
        Id.getElementsByClassName("kgrqDay")[0].innerText.trim(); //开工时间日
      this.detailForm.jgrqYear =
        Id.getElementsByClassName("jgrqYear")[0].innerText.trim(); //交工时间年
      this.detailForm.jgrqMonth =
        Id.getElementsByClassName("jgrqMonth")[0].innerText.trim(); //交工时间月
      this.detailForm.jgrqDay =
        Id.getElementsByClassName("jgrqDay")[0].innerText.trim(); //交工时间日
      this.detailForm.htgqHoleDay =
        Id.getElementsByClassName("htgqHoleDay")[0].innerText.trim(); //合同工期总日历天数为
      this.detailForm.hszjDX =
        Id.getElementsByClassName("hszjDX")[0].innerText.trim(); //含税总价大写
      Id.getElementsByClassName("hszjDX")[0].innerHTML = this.detailForm.hszjDX;
      Id.getElementsByClassName("kgrqYear")[0].innerHTML =
        this.detailForm.kgrqYear;
      Id.getElementsByClassName("kgrqMonth")[0].innerHTML =
        this.detailForm.kgrqMonth;
      Id.getElementsByClassName("kgrqDay")[0].innerHTML =
        this.detailForm.kgrqDay;
      Id.getElementsByClassName("jgrqYear")[0].innerHTML =
        this.detailForm.jgrqYear;
      Id.getElementsByClassName("jgrqMonth")[0].innerHTML =
        this.detailForm.jgrqMonth;
      Id.getElementsByClassName("jgrqDay")[0].innerHTML =
        this.detailForm.jgrqDay;

      this.detailForm.hszjXJ =
        Id.getElementsByClassName("hszjXJ")[0].innerText.trim(); //含税总价小写
      this.detailForm.bhsj =
        Id.getElementsByClassName("bhsj")[0].innerText.trim(); //不含税价
      this.detailForm.sf = Id.getElementsByClassName("sf")[0].innerText.trim(); //税费
      this.detailForm.zlbzssyd =
        Id.getElementsByClassName("zlbzssyd")[0].innerText.trim(); //本工程质量标准双方约定为
      Id.getElementsByClassName("hszjXJ")[0].innerHTML = this.detailForm.hszjXJ;
      Id.getElementsByClassName("bhsj")[0].innerHTML = this.detailForm.bhsj;
      Id.getElementsByClassName("sf")[0].innerHTML = this.detailForm.sf;
      Id.getElementsByClassName("zlbzssyd")[0].innerHTML =
        this.detailForm.zlbzssyd;

      this.detailForm.htdlYear =
        Id.getElementsByClassName("htdlYear")[0].innerText.trim(); //合同订立时间年
      this.detailForm.htdlMonth =
        Id.getElementsByClassName("htdlMonth")[0].innerText.trim(); //合同订立时间月
      this.detailForm.htdlDay =
        Id.getElementsByClassName("htdlDay")[0].innerText.trim(); //合同订立时间日
      this.detailForm.htdlAddress =
        Id.getElementsByClassName("htdlAddress")[0].innerText.trim(); //合同订立地点
      Id.getElementsByClassName("htdlYear")[0].innerHTML =
        this.detailForm.htdlYear;
      Id.getElementsByClassName("htdlMonth")[0].innerHTML =
        this.detailForm.htdlMonth;
      Id.getElementsByClassName("htdlDay")[0].innerHTML =
        this.detailForm.htdlDay;
      Id.getElementsByClassName("htdlAddress")[0].innerHTML =
        this.detailForm.htdlAddress;

      //第九条，合同的期限
      this.detailForm.htPartA =
        Id.getElementsByClassName("htPartA")[0].innerText; //甲方
      this.detailForm.fddbrOthers =
        Id.getElementsByClassName("fddbrOthers")[0].innerText.trim(); //
      this.detailForm.wtdlr =
        Id.getElementsByClassName("wtdlr")[0].innerText.trim(); //委托代理人
      this.detailForm.phone =
        Id.getElementsByClassName("phone")[0].innerText.trim(); //电话
      this.detailForm.email =
        Id.getElementsByClassName("email")[0].innerText.trim(); //合同订立地点
      this.detailForm.openBank =
        Id.getElementsByClassName("openBank")[0].innerText; //合同订立地点
      this.detailForm.account =
        Id.getElementsByClassName("account")[0].innerText.trim(); //合同订立地点
      this.detailForm.workAddress =
        Id.getElementsByClassName("workAddress")[0].innerText; //合同订立地点
      Id.getElementsByClassName("fddbrOthers")[0].innerHTML =
        this.detailForm.fddbrOthers;
      Id.getElementsByClassName("wtdlr")[0].innerHTML = this.detailForm.wtdlr;
      Id.getElementsByClassName("phone")[0].innerHTML = this.detailForm.phone;
      Id.getElementsByClassName("email")[0].innerHTML = this.detailForm.email;
      Id.getElementsByClassName("openBank")[0].innerHTML =
        this.detailForm.openBank;
      Id.getElementsByClassName("account")[0].innerHTML =
        this.detailForm.account;
      Id.getElementsByClassName("workAddress")[0].innerHTML =
        this.detailForm.workAddress;

      this.detailForm.emailYB =
        Id.getElementsByClassName("emailYB")[0].innerText.trim(); //合同订立地点
      this.detailForm.htPartB =
        Id.getElementsByClassName("htPartB")[0].innerText; //合同订立地点
      this.detailForm.fddbrOthersB =
        Id.getElementsByClassName("fddbrOthersB")[0].innerText.trim(); //合同订立地点
      this.detailForm.wtdlrB =
        Id.getElementsByClassName("wtdlrB")[0].innerText.trim(); //合同订立地点
      this.detailForm.phoneB =
        Id.getElementsByClassName("phoneB")[0].innerText.trim(); //合同订立地点
      this.detailForm.emailB =
        Id.getElementsByClassName("emailB")[0].innerText.trim(); //合同订立地点
      this.detailForm.openBankB =
        Id.getElementsByClassName("openBankB")[0].innerText; //合同订立地点
      this.detailForm.accountB =
        Id.getElementsByClassName("accountB")[0].innerText.trim(); //合同订立地点
      this.detailForm.workAddressB =
        Id.getElementsByClassName("workAddressB")[0].innerText; //合同订立地点
      this.detailForm.emailYBB =
        Id.getElementsByClassName("emailYBB")[0].innerText.trim(); //合同订立地点

      Id.getElementsByClassName("emailYB")[0].innerHTML =
        this.detailForm.emailYB;
      Id.getElementsByClassName("htPartB")[0].innerHTML =
        this.detailForm.htPartB;
      Id.getElementsByClassName("fddbrOthersB")[0].innerHTML =
        this.detailForm.fddbrOthersB;
      Id.getElementsByClassName("wtdlrB")[0].innerHTML = this.detailForm.wtdlrB;
      Id.getElementsByClassName("phoneB")[0].innerHTML = this.detailForm.phoneB;
      Id.getElementsByClassName("emailB")[0].innerHTML = this.detailForm.emailB;

      Id.getElementsByClassName("openBankB")[0].innerHTML =
        this.detailForm.openBankB;
      Id.getElementsByClassName("accountB")[0].innerHTML =
        this.detailForm.accountB;
      Id.getElementsByClassName("workAddressB")[0].innerHTML =
        this.detailForm.workAddressB;
      Id.getElementsByClassName("emailYBB")[0].innerHTML =
        this.detailForm.emailYBB;
      //第二部分，合同条款
      this.detailForm.value1 =
        Id.getElementsByClassName("value1")[0].innerText.trim(); //合同订立地点
      this.detailForm.value2 = Id.getElementsByClassName("value2")[0].innerText; //合同订立地点
      this.detailForm.bk1 = Id.getElementsByClassName("bk1")[0].innerText; //合同订立地点
      this.detailForm.projectMsgerA =
        Id.getElementsByClassName("projectMsgerA")[0].innerText.trim(); //项目经理
      this.detailForm.workA =
        Id.getElementsByClassName("workA")[0].innerText.trim(); //职务
      this.detailForm.cphoneA =
        Id.getElementsByClassName("cphoneA")[0].innerText.trim(); //职务
      this.detailForm.caddressA =
        Id.getElementsByClassName("caddressA")[0].innerText.trim(); //职务
      this.detailForm.cemailA =
        Id.getElementsByClassName("cemailA")[0].innerText.trim(); //职务

      Id.getElementsByClassName("value1")[0].innerHTML = this.detailForm.value1;
      Id.getElementsByClassName("value2")[0].innerHTML = this.detailForm.value2;
      Id.getElementsByClassName("bk1")[0].innerHTML = this.detailForm.bk1;
      Id.getElementsByClassName("projectMsgerA")[0].innerHTML =
        this.detailForm.projectMsgerA;
      Id.getElementsByClassName("workA")[0].innerHTML = this.detailForm.workA;
      Id.getElementsByClassName("cphoneA")[0].innerHTML =
        this.detailForm.cphoneA;
      Id.getElementsByClassName("caddressA")[0].innerHTML =
        this.detailForm.caddressA;
      Id.getElementsByClassName("cemailA")[0].innerHTML =
        this.detailForm.cemailA;

      this.detailForm.projectMsgerB =
        Id.getElementsByClassName("projectMsgerB")[0].innerText.trim(); //合同订立地点
      this.detailForm.workB =
        Id.getElementsByClassName("workB")[0].innerText.trim(); //职务
      this.detailForm.cphoneB =
        Id.getElementsByClassName("cphoneB")[0].innerText.trim(); //职务
      this.detailForm.caddressB =
        Id.getElementsByClassName("caddressB")[0].innerText.trim(); //职务
      this.detailForm.cemailB =
        Id.getElementsByClassName("cemailB")[0].innerText.trim(); //职务
      Id.getElementsByClassName("projectMsgerB")[0].innerHTML =
        this.detailForm.projectMsgerB;
      Id.getElementsByClassName("workB")[0].innerHTML = this.detailForm.workB;
      Id.getElementsByClassName("cphoneB")[0].innerHTML =
        this.detailForm.cphoneB;
      Id.getElementsByClassName("caddressB")[0].innerHTML =
        this.detailForm.caddressB;
      Id.getElementsByClassName("cemailB")[0].innerHTML =
        this.detailForm.cemailB;

      //履约担保
      this.detailForm.YorNlydb =
        Id.getElementsByClassName("YorNlydb")[0].innerText.trim(); //职务
      this.detailForm.lydbType =
        Id.getElementsByClassName("lydbType")[0].innerText.trim(); //职务
      this.detailForm.zjhtRito =
        Id.getElementsByClassName("zjhtRito")[0].innerText.trim(); //职务
      this.detailForm.zjhtPrice =
        Id.getElementsByClassName("zjhtPrice")[0].innerText.trim(); //职务
      this.detailForm.jgcl =
        Id.getElementsByClassName("jgcl")[0].innerText.trim(); //职务
      Id.getElementsByClassName("YorNlydb")[0].innerHTML =
        this.detailForm.YorNlydb;
      Id.getElementsByClassName("lydbType")[0].innerHTML =
        this.detailForm.lydbType;
      Id.getElementsByClassName("zjhtRito")[0].innerHTML =
        this.detailForm.zjhtRito;
      Id.getElementsByClassName("zjhtPrice")[0].innerHTML =
        this.detailForm.zjhtPrice;
      Id.getElementsByClassName("jgcl")[0].innerHTML = this.detailForm.jgcl;

      this.detailForm.contractType =
        Id.getElementsByClassName("contractType")[0].innerText.trim(); //h合同类型
      this.detailForm.gcbxj =
        Id.getElementsByClassName("gcbxj")[0].innerText.trim(); //工程保修金
      this.detailForm.lybzj =
        Id.getElementsByClassName("lybzj")[0].innerText.trim(); //履约保证金
      this.detailForm.zjbzj =
        Id.getElementsByClassName("zjbzj")[0].innerText.trim(); //履约保证金
      this.detailForm.fxdyj =
        Id.getElementsByClassName("fxdyj")[0].innerText.trim(); //履约保证金
      this.detailForm.tjsj =
        Id.getElementsByClassName("tjsj")[0].innerText.trim(); //履约保证金
      this.detailForm.tjfs =
        Id.getElementsByClassName("tjfs")[0].innerText.trim(); //履约保证金
      this.detailForm.wyj =
        Id.getElementsByClassName("wyj")[0].innerText.trim(); //履约保证金
      this.detailForm.wyj1 =
        Id.getElementsByClassName("wyj1")[0].innerText.trim(); //履约保证金
      this.detailForm.wyj2 =
        Id.getElementsByClassName("wyj2")[0].innerText.trim(); //履约保证金
      this.detailForm.wyj3 =
        Id.getElementsByClassName("wyj3")[0].innerText.trim(); //履约保证金

      this.detailForm.contractNum =
        Id.getElementsByClassName("contractNum")[0].innerText.trim(); //职务
      this.detailForm.contractNumA =
        Id.getElementsByClassName("contractNumA")[0].innerText.trim(); //职务
      this.detailForm.contractNumB =
        Id.getElementsByClassName("contractNumB")[0].innerText.trim(); //职务
      this.detailForm.addContent =
        Id.getElementsByClassName("addContent")[0].innerText.trim(); //补充协议

      this.detailForm.monthReto =
        Id.getElementsByClassName("monthReto")[0].innerText.trim(); //为月进度款

      Id.getElementsByClassName("contractNum")[0].innerHTML =
        this.detailForm.contractNum;
      Id.getElementsByClassName("contractNumA")[0].innerHTML =
        this.detailForm.contractNumA;
      Id.getElementsByClassName("contractNumB")[0].innerHTML =
        this.detailForm.contractNumB;
      Id.getElementsByClassName("addContent")[0].innerHTML =
        this.detailForm.addContent;
      Id.getElementsByClassName("monthReto")[0].innerHTML =
        this.detailForm.monthReto;
      Id.getElementsByClassName("htgqHoleDay")[0].innerHTML =
        this.detailForm.htgqHoleDay;
      this.detailForm.gqDelay =
        Id.getElementsByClassName("gqDelay")[0].innerText.trim(); //工期拖延
      Id.getElementsByClassName("gqDelay")[0].innerHTML =
        this.detailForm.gqDelay;
      this.detailForm.htAmount =
        Id.getElementsByClassName("htAmount")[0].innerText.trim(); //工期拖延
      Id.getElementsByClassName("htAmount")[0].innerHTML =
        this.detailForm.htAmount;
      //
      this.detailForm.jchtqtsy =
        Id.getElementsByClassName("jchtqtsy")[0].innerText; //工期拖延
      Id.getElementsByClassName("jchtqtsy")[0].innerHTML =
        this.detailForm.jchtqtsy;
    },
    //打印当前合同
    PrintContractA() {
      if (this.watermark[0] == undefined) this.watermark[0] = "";
      if (this.dialogForm.approveStatus != 3) {
        this.$alert("合同尚未通过审核，无法打印", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      // let Id = document.getElementById("HTMLLaborContract");
      let Id = document.getElementsByClassName(this.printClass)[0];
      let elementsToRemove = Id.querySelectorAll(".page-num");
      elementsToRemove.forEach(function (element) {
        element.parentNode.removeChild(element);
      });
      //addPageNum(Id, 1, "LaborContract");

      //首页项目名称超过一行时删除一个空白行
      var prjNameHeight = document.getElementById("projectName").offsetHeight;
      var spaceLine = document.getElementById("spaceLine");
      if (prjNameHeight > 80) {
        spaceLine.style.display = 'none';
      } else {
        spaceLine.style.display = 'block';
      }

      //分区域计算总页数，首页和签字页是单独起页
      let first_part = document.getElementById("first_part");
      let count1 = Math.ceil(parseFloat(first_part.offsetHeight) / 1010);
      console.log("first_part:" + count1)

      let second_part = document.getElementById("second_part");
      let count2 = Math.ceil(parseFloat(second_part.offsetHeight) / 1010);
      console.log("second_part:" + count2)

      let total = count1 + count2 + 2;
      console.log("total page:" + total)

      total = this.inputPages ? parseFloat(this.inputPages)+1 : total;
      addPageNumCustom(Id, 1, "LaborContract", total, this.inputHeight, this.inputPosx);

      this.$set(
        this,
        "laborContractContent",
        this.$refs.HTMLLaborContract.innerHTML
      );
      this.$nextTick(() => {
        printJS({
          printable: "printLaborContractContent",
          type: "html",
          targetStyles: ["*"],
          ignoreElements: ["no-print", "bc", "gb"],
          scanStyles: false,
          style: `@page { size: auto; margin:10mm  } p{line-height:37px;} .HTMLLaborContract1 {background: url("data:image/svg+xml,%3Csvg width='200' height='200' xmlns='http://www.w3.org/2000/svg'%3E%3Ctext x='50%25' y='50%25' font-size='14' fill-opacity='0.3' text-anchor='middle' dominant-baseline='middle' transform='rotate(-35, 100 100)'%3E${this.watermark[0]}%3C/text%3E%3C/svg%3E");
}`,
        });
      });
    },
    //设置水印
    setWatermark() {
      this.$refs.setWatermarking.showwaterMarkDialog(
        this.subServiceContractId,
        this.watermark
      );
    },
    setWaterMarkFun(val) {
      this.watermark = val;
      let param = {
        warterMark: this.watermark,
        version: "1.0",
        flag: 2,
      };
      this.$emit("savePrintInfo", param);
    },
  },
};
</script>
<style>
#HTMLLaborContract {
  box-sizing: border-box;
  box-shadow: 0px 4px 12px 2px #bbb;
  /* position: relative; */
  padding: 0 10px;
  width: 20cm;
  margin-top: 58px;
}
p {
  line-height: 37px;
}
.buttons {
  width: 22cm;
  height: 56px;
  position: fixed;
  top: 90px;
  background: white;
  z-index: 2;
}

.printWrap {
  width: 21cm;
  margin: 30px auto;
  padding: 5mm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}

.mainHtml {
  width: 21cm;
}
</style>
